import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import { isEqual } from 'lodash'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import EventEmitter from '../../../../utils/events'

// Actions
import { triggerPopup, triggerPopupActionBG } from '../../../../actions/backdrop'
import { deleteNote } from '../../../../actions/notes'
import {
  uploadFileToOrder, deleteFileFromOrder, saveOrder, setWorkcardOrder,
  bookOrder, isFileReady, getOrderVehicleData, getOrderClean
} from '../../../../actions/orders'
import { getInsuranceCompanies } from '../../../../actions/insurancecompanies'
import { getCustomer } from '../../../../actions/customers'
import { getPrices, updatePrices } from '../../../../actions/orderPrice'
import { getPriceInformations } from '../../../../actions/priceModel'
import { setPhoneCodes, setBrands, setEnums, setCountries, setPageTitle, openOverlay } from '../../../../actions/common'
import { GetSimpleCarRentals } from '../../../../actions/shops'
import { checkVehicleForCustomers } from '../../../../actions/dracar'
import { GetAssignments } from '../../../../actions/carrental'

// Styles
import './workcard.scss'
// Components
import Confirm from '../../../../shared/components/Confirm'
import Portal from '../../../../shared/components/Portal'
import HelpText from '../../../../shared/components/HelpText'
import Invoice from '../../../../shared/components/Invoice'

// import modals
import NotesModal from '../../../../shared/modals/NotesModal'
import CreateEstimationModal from '../../../../shared/modals/CreateEstimationModal'
import SetCustomer from '../../OrderList/NewItem/SetCustomer'
import PriceApprovalModal from '../../../../shared/modals/PriceApprovalModal'
import HandleCarRentalModal from '../../../../shared/modals/HandleCarRentalModal'
import OkModal from '../../../../shared/modals/OkModal'

// Utils
import { translation, getOrderNoteShareString } from '../../../../utils/helpers'
import { renderFullDate } from '../../../../utils/time'
import { hasSubscriptionPermission, hasAccess, hasPartnerSubscriptionPermission } from '../../../../utils/auth'
import { makeOrderPageTitleObject } from '../../../../utils/order'

// Constants
import { DracarAllowOrderTypes, OrderTypes, CarRentalSystemTypes } from '../../../../constants'

import Header from '../../../../shared/components/Header'
import WhiteBox from './WhiteBox'
import OrderExtent from './OrderExtent'
import SpareParts from './SpareParts'
import Files from './Files'
import InputRender from './InputRender'
import RadioList from './InputComponents/RadioList'
// import OrderDate from './OrderDate'
import CarRentalContract from './CarRentalContract'
import OrderBookingButton from '../../../Orders/OrderBookingButton'
import ConfirmOk from '../../../../shared/components/ConfirmOk'
import UserInfo from '../../../../shared/components/UserInfo'
import ForsiCreateReport from '../../../../shared/components/ForsiCreateReport'
import Dracar from '../../../../shared/components/Dracar'
import CarRentalAssignmentList from '../../../../shared/components/CarRentalAssignmentList'

// Elements
import Panel from '../../../../shared/elements/panel'
import PanelHeader from '../../../../shared/elements/panelHeader'
import Col from '../../../../shared/elements/col'
import Text from '../../../../shared/elements/text'
import DropDown from '../../../../shared/elements/dropDown'
import Button from '../../../../shared/elements/button'
import LabelWrapper from '../../../../shared/elements/labelWrapper'
import Divider from '../../../../shared/elements/divider'
import Inline from '../../../../shared/elements/inline'
import Grid from '../../../../shared/elements/grid'
import Label from '../../../../shared/elements/label'
import TimeSpan from '../../../../shared/elements/timeSpan'

// Language
import { InitLanguage, setTranslations, setLanguage, setLanguages } from '../../../../language'

// Redux
import store from '../../../../store'
import BookingTimes from '../../../../shared/components/BookingTimes'
import CarOwnerPortalInviteStatus from '../../../../shared/components/CarOwnerPortalInviteStatus'

export const Below650 = [0, 650]
export const Below1055 = [0, 1055]
export const Above650 = [650, 10000]
export const Between650And1401 = [650, 1401]
export const Above1055 = [1055, 10000]
export const Between1055And1400 = [1055, 1400]
export const Above1400 = [1400, 10000]
class WorkCard extends Component {

  constructor (props) {
    super(props)
    this.checkOrderTimeoutId = 0
    this.state = {
      carOwnerPhoneCount: 1,
      handleCarRentalPopup: {
        show: false
      },
      notePopup: {
        showNotePopup: false,
        note: {}
      },
      createEstimationPopup: {
        show: false
      },
      showSetCustomerPopup: {
        show: false
      },
      dracarInfoPopup: {
        show: false
      },
      upload: {
        loading: false,
        errors: []
      },
      altAddress: {
        delivery: false,
        pickup: false,
        BodyShopDelivery: false,
        BodyShopPickup: false
      },
      order: undefined,
      previousOrder: null,
      contacts: [],
      createdNew: false,
      saved: false,
      errors: false,
      success: false,
      dimensions: {
        width: 0,
        height: 0
      },
      refreshPrices: false,
      confirm: {
        open: false,
        type: 0
      },
      confirmDelete: {
        open: false,
        NoteID: 0
      },
      confirmPaintNotBooked: {
        open: false
      },
      confirmMissingBodywork: {
        show: false
      },
      priceInformation: null,
      loosepartChangeConfirmDialogOpen: false,
      updating: false,
      InsuranceCompanies: [],
      canWPEdit: false,
      invoice: {}
    }
    this.saveWorkcard = this.saveWorkcard.bind(this)
    this.updateWorkcard = this.updateWorkcard.bind(this)
    this.bookOrder = this.bookOrder.bind(this)
    this.onInputChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.onCarOwnerBlur = this.onCarOwnerBlur.bind(this)
    this.onRegBlur = this.onRegBlur.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
    this.renderCreateEstimationPopup = this.renderCreateEstimationPopup.bind(this)
    this.onCreateEstimationSave = this.onCreateEstimationSave.bind(this)
    this.getContacts = this.getContacts.bind(this)
    this.setupPrint = this.setupPrint.bind(this)
    this.clearPrint = this.clearPrint.bind(this)
    this.updateFromOrderSocket = this.updateFromOrderSocket.bind(this)
    this.renderSetCustomerPopup = this.renderSetCustomerPopup.bind(this)
    this.renderInsuranceDisplay = this.renderInsuranceDisplay.bind(this)
    this.saveSingleValue = this.saveSingleValue.bind(this)
    this.togglePopup = this.togglePopup.bind(this)
    this.onChange = this.onChange.bind(this)
    this.getChildContext = this.getChildContext.bind(this)
    this.getInputRender = this.getInputRender.bind(this)
    this.renderInvoice = this.renderInvoice.bind(this)
    this.getPriceInformations = this.getPriceInformations.bind(this)
    this.renderLoosepartPriceChangePopup = this.renderLoosepartPriceChangePopup.bind(this)
    this.renderConfirmPaintNotBooked = this.renderConfirmPaintNotBooked.bind(this)
    this.renderCarRentalList = this.renderCarRentalList.bind(this)
    this.renderHandleCarRentalPopup = this.renderHandleCarRentalPopup.bind(this)
    this.renderDracarInfoPopup = this.renderDracarInfoPopup.bind(this)
    this.onNewOrderCreated = this.onNewOrderCreated.bind(this)
    this.renderReferred = this.renderReferred.bind(this)
    this.renderCarOwnerPortal = this.renderCarOwnerPortal.bind(this)
    this.onTimeSpanBlur = this.onTimeSpanBlur.bind(this)
    this.onBookingTimesUpdated = this.onBookingTimesUpdated.bind(this)
    // this.showNotePopup = this.showNotePopup.bind(this)
    console.log('Workcard ctor')
  }

  getChildContext () {
    return {
      dimensions: this.state.dimensions,
      onBlur: this.onBlur,
      onChange: this.onChange,
      onUpdateOrder: this.props.onUpdateOrder,
      saveWorkcard: this.saveWorkcard,
      disabledForWP: hasAccess([6], this.props.auth.user.UserType) && !this.state.canWPEdit
    }
  }
  getInputRender (translateName, propName, formatter, type, listItems, listItemValName, translate) {
    let onBlur // is undefined on purpose! InputRender will use onBlur from context as long as it is undefined from props
    if (['RegNumber', 'ChassisNumber'].includes(propName)) onBlur = this.onRegBlur
    if (['CarOwnerMail'].includes(propName)) onBlur = this.onCarOwnerBlur
    if (propName === 'BodyShopTransport' || propName === 'Transport') {
      let transformedList = this.removeLoosePart(propName, listItems)
      if (transformedList !== undefined) {
        return <InputRender translateName={translateName} formatter={formatter} propName={propName} type={type} listItems={transformedList} listItemValName={listItemValName} onBlur={onBlur} order={this.state.order} translate={translate} />
      }
    }

    return <InputRender translateName={translateName} formatter={formatter} propName={propName} type={type} listItems={listItems} listItemValName={listItemValName} onBlur={onBlur} order={this.state.order} translate={translate} />
  }
  removeLoosePart (propName, listItems) {
    if (((!hasSubscriptionPermission(this.props.auth, 10) && propName === 'BodyShopTransport') || (!hasSubscriptionPermission(this.props.auth, 10) && !hasPartnerSubscriptionPermission(this.props.auth, 10) && propName === 'Transport')) && listItems.length > 0) {
      const list = listItems.slice(0)
      for (var i = 0; i < listItems.length; i++) {
        if (listItems[i].Id === 2) {
          list.splice(i, 1)
          return list
        }
      }
      return list
    }
    return listItems
  }

  componentDidMount () {
    // get resources if missing
    let common = this.props.common
    if (common.phonecodes.length === 0 ||
      common.brands.length === 0 ||
      common.countries.length === 0) {
      InitLanguage().then((res) => {
        // Set translations
        store.dispatch(setTranslations(res.translations))
        store.dispatch(setLanguages(res.langs))

        // Set rest
        store.dispatch(setPhoneCodes(res.data.PhoneCodes))
        store.dispatch(setBrands(res.data.Brands))
        store.dispatch(setEnums(res.data.Enums))
        store.dispatch(setCountries(res.data.Countries))

        // Set user language
        if (typeof window.localStorage.user_language !== 'undefined') {
          store.dispatch(setLanguage(window.localStorage.user_language))
        }
      })
    }

    this.setupPrint()
    this.checkOrder()
    this.setBodyClass(false)
    window.addEventListener('resize', this.updateDimensions)
    this.updateDimensions()
    this.renderCarRentalList()
    this.props.getInsuranceCompanies().then(res => {
      this.setState({ InsuranceCompanies: res.data.Item2 })
    })

    if (this.props.router.location.query.notifyPaintNotBooked !== undefined) {
      // console.log('Should show paint not booked dialog...')
      this.setState({ confirmPaintNotBooked: { open: true } })
      this.props.router.replace(this.props.router.location.pathname)
    }

    // Listen for socket
    EventEmitter.addListener('ORDER_SOCKET', this.updateFromOrderSocket, this)

    // Set order
    this.setState({
      order: this.props.order,
      altAddress: {
        delivery: this.props.order.DeliveryAltLocationId !== 0,
        pickup: this.props.order.PickupAltLocationId !== 0,
        BodyShopDelivery: this.props.order.BodyShopDeliveryAltLocationId !== 0,
        BodyShopPickup: this.props.order.BodyShopPickupAltLocationId !== 0
      },
      contacts: []
    }, this.getContacts)

    if (this.props.order.PreviousOrder !== undefined && this.props.order.PreviousOrder !== null) {
      this.props.getOrderClean(this.props.order.PreviousOrder).then((res) => {
        let hasForsiReport = res.data.Report !== null && res.data.Report.ReportType === 1
        // res.data.ForsiOrderExtent !== null
        if (hasForsiReport && res.data.Report.Paint) {
          // console.log('got order', res.data)
          this.setState({ previousOrder: res.data })
        }
      })
    }
    if (this.props.createdNew === true) {
      this.setState({ createdNew: true }, this.onNewOrderCreated)
    }
    this.app = ReactDOM.findDOMNode(document.getElementsByClassName('workcard__screen')[0])
    this.app.addEventListener('DOMSubtreeModified', this.checkForPopups)
  }

  componentWillUnmount () {
    // If checkOrder() hasn't been executed yet
    clearTimeout(this.checkOrderTimeoutId)
    this.setBodyClass(true)
    window.removeEventListener('resize', this.updateDimensions)
    EventEmitter.removeListener('ORDER_SOCKET', this.updateFromOrderSocket)
    this.clearPrint()
  }

  updateFromOrderSocket (json) {
    if (!this.props.auth.user.DeviceToken) return
    if (json.Data === undefined || json.Data === null || json.Data.Id !== this.props.order.Id) return
    if (json.DeviceToken === this.props.auth.user.DeviceToken) return    // Don't update if socket message was initiated by current device.

    if (json.Type === 'ORDER_UPDATE') {
      setTimeout(this.props.onUpdateOrder(), 500)
    }
  }

  onBookingTimesUpdated () {
    if (this.props.order && Array.isArray(this.props.order.CarRentalAssignments) && this.props.order.CarRentalAssignments.length > 0) {
      this.props.GetAssignments(this.props.order.Id, false, false).then(res => {
        console.log('onBookingTimesUpdated')
        this.props.onUpdateOrder({...this.props.order, CarRentalAssignments: res.data.Assignments})
      })
    }
  }

  setupPrint () {
    var beforePrint = () => {
      // Rearrange boxes
      let row = document.getElementsByClassName('row clearfix')
      if (row.length !== 0) {
        row[0].style.display = 'none'
        // Make boxes HTML
        let tempDomCols = ['<div class="col">', '<div class="col">']
        let columns = [[], []]
        let dataColElements = document.querySelectorAll('[data-col]')
        for (let i = 0; i < dataColElements.length; i++) {
          console.log('Box[' + i + ']', dataColElements[i])
        }
        let orderDepartment = this.state.order.OrderDepartment
        var dataCols = []
        for (let i = 0; i < dataColElements.length; i++) {
          let colAttr = dataColElements[i].getAttribute('data-col')
          if (colAttr !== null && colAttr !== '') dataCols.push(colAttr)
        }

        for (let i = 0; i < dataColElements.length; i++) {
          let col = dataColElements[i].getAttribute('data-col')
          if (col === null) continue
          let outerHTML = dataColElements[i].outerHTML

          // Paint
          let colConfigs = [ // [col1], [col2]
            ['order', 'customer'],
            ['notes', 'color'],
            ['files', 'transport'],
            [null, 'vehicle']]

          // Body
          if (orderDepartment !== 0) {
            colConfigs = [
              ['bodyshoporder2', null],
              ['bodyshoporder', 'order'],
              ['bodyshoptransport', 'transport'],
              ['vehicle', 'spareparts'],
              ['carownercustomer', 'color'],
              ['notes', 'customer'],
              [null, 'files']
            ]
          }
          colConfigs.map((config, index) => {
            config.map((val, colIndex) => {
              if (val && val === col) {
                columns[colIndex][index] = outerHTML
              }
            })
          })
        }
        tempDomCols.map((value, i) => {
          columns[i].map(val => {
            tempDomCols[i] += val
          })
          tempDomCols[i] += '</div>'
        })

        // Combine all
        let joined = tempDomCols[0] + tempDomCols[1] // + '<div class="col"></div>'

        let rowPrintElements = document.getElementsByClassName('rowPrint')
        if (rowPrintElements !== null && rowPrintElements.length > 0) {
          rowPrintElements[0].innerHTML = joined
        }

        // Handle browsers with identity crisis:
        let isIExplorer = navigator.appCodeName.indexOf('Mozilla') !== -1 && navigator.appName.indexOf('Netscape') !== -1 && navigator.appVersion.indexOf('like Gecko') !== -1 && navigator.appVersion.indexOf('Apple') === -1 && navigator.appVersion.indexOf('Chrome') === -1
        let isEdge = navigator.appCodeName.indexOf('Mozilla') !== -1 && navigator.appName.indexOf('Netscape') !== -1 && navigator.appVersion.indexOf('Edge') !== -1

        var oldInputs = row[0].getElementsByTagName('input')
        if (rowPrintElements !== null && rowPrintElements.length > 0) {
          var newInputs = rowPrintElements[0].getElementsByTagName('input')
          for (let i = 0; i < oldInputs.length; i++) {
            if (oldInputs[i].type === 'checkbox' || oldInputs[i].type === 'radio') {
              for (let x = 0; x < newInputs.length; x++) {
                // Handle checkboxes
                if (newInputs[x].type === 'checkbox') {
                  if (newInputs[x].name === oldInputs[i].name) {
                    if (oldInputs[i].checked) {
                      newInputs[x].checked = oldInputs[i].checked
                      if (newInputs[x].name.startsWith('BodyShopTransport')) {
                        newInputs[x].parentNode.removeChild(newInputs[x])
                      }
                    } else {
                      if (newInputs[x].name.startsWith('BodyShopTransport')) {
                        newInputs[x].parentElement.parentElement.parentElement.remove() // Fails in IE (no longer supported)
                      }
                    }
                  }

                // Handle radiobuttons
                } else if (newInputs[x].type === 'radio') {
                  if (oldInputs[i].id === newInputs[x].id) {
                    if (oldInputs[i].checked) {
                      newInputs[x].checked = oldInputs[i].checked
                      newInputs[x].parentNode.removeChild(newInputs[x])
                    } else {
                      newInputs[x].parentElement.parentElement.parentElement.remove() // Fails in IE
                    }
                  }
                }
              }
            }
          }
        }

        var updatedSelects = []
        var oldSelects = row[0].getElementsByTagName('select')
        if (rowPrintElements !== null && rowPrintElements.length > 0) {
          var newSelects = rowPrintElements[0].getElementsByTagName('select')
          for (let o = 0; o < oldSelects.length; o++) {
            for (let n = 0; n < newSelects.length; n++) {
              if (newSelects[n].name === oldSelects[o].name && updatedSelects.indexOf(newSelects[n].name) === -1 && (oldSelects[o].value !== '' && oldSelects[o].value !== null)) {
                if (isIExplorer || isEdge) {
                  setSelectIeEdge(newSelects[n], oldSelects[o].value)
                } else {
                  newSelects[n].value = oldSelects[o].value
                }
                updatedSelects.push(newSelects[n].name)
              }
            }
          }
        }
      }
    }

    const setSelectIeEdge = (select, value) => {
      Array.prototype.forEach.call(select.children, (option) => { if (option.value === value.toString()) { option.selected = true } })
    }

    var afterPrint = () => {
      // console.log('after print')
      // return
      // Set boxes back to normal
      let row = document.getElementsByClassName('row clearfix')
      if (row.length !== 0) {
        row[0].style.display = 'block'
        let elements = document.getElementsByClassName('rowPrint')
        if (elements !== null && elements.length > 0) {
          elements[0].innerHTML = ''
        }
      }
    }

    if (window.matchMedia) {
      var mediaQueryList = window.matchMedia('print')
      mediaQueryList.addListener((mql) => {
        if (mql.matches) {
          beforePrint()
        } else {
          afterPrint()
        }
      })
    }

    window.onbeforeprint = beforePrint
    window.onafterprint = afterPrint
  }

  clearPrint () {
    window.onbeforeprint = undefined
    window.onafterprint = undefined
  }

  setBodyClass (out) {
    setTimeout(() => {
      if (out) {
        document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className.replace('order__body', '')
      } else {
        document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className + ' order__body'
      }
    }, 0)
  }

  checkForPopups () {
    let item = document.getElementsByClassName('helperTextModal')[0]
    if (item !== undefined) {
      let bounding = item.getBoundingClientRect()
      let windowWith = window.innerWidth
      if (bounding.left < 0) {
        if (windowWith > ((bounding.width * 2) + bounding.left)) {
          item.style.cssText = ('right:' + bounding.left + 'px' + ' !important')
          // item.style.right = bounding.left
        } else {
          let margin = (windowWith - bounding.width) / 2
          item.style.cssText = ('right:' + (bounding.left - margin) + 'px' + ' !important')
          // item.style.right = bounding.left - margin
        }
      }

      if (bounding.right < 0) {
        if (windowWith > ((bounding.width * 2) + bounding.right)) {
          item.style.cssText = ('left:' + bounding.right + 'px' + ' !important')
          // item.style.right = 0
        } else {
          let margin = (windowWith - bounding.width) / 2
          item.style.cssText = ('left:' + (bounding.right - margin) + 'px' + ' !important')
          // item.style.left = bounding.right - margin
        }
      }
    }
  }

  updateDimensions () {
    let w = window
    let d = document
    let documentElement = d.documentElement
    let body = d.getElementsByTagName('body')[0]

    let width = w.innerWidth || documentElement.clientWidth || body.clientWidth
    let height = w.innerHeight || documentElement.clientHeight || body.clientHeight

    this.setState({
      dimensions: {
        width: width,
        height: height
      }
    })
  }

  componentWillReceiveProps (nextProps) {
    let contacts = []
    if (this.state.order && this.state.order.CustomerId && nextProps.order.CustomerId === this.state.order.CustomerId) {
      contacts = this.state.contacts
    }

    let order = nextProps.order
    if (order.carOwnerPhoneCount) {
      let phoneCount = order.CarOwnerPhones.length
      if (phoneCount > this.state.carOwnerPhoneCount) this.state.carOwnerPhoneCount = phoneCount
      for (let i = phoneCount; i < this.state.carOwnerPhoneCount; i++) {
        order.CarOwnerPhones.push('')
      }
    }

    this.setState({
      order: order,
      altAddress: {
        delivery: order.DeliveryAltLocationId !== 0,
        pickup: order.PickupAltLocationId !== 0
      },
      contacts: contacts
    }, () => {
      if (order.CustomerId !== this.state.order.CustomerId) this.getContacts()
      if (!this.state.priceInformation) this.getPriceInformations()
    })

  // }
  //   }, this.getContacts) // merge made a mess
  }
  onNewOrderCreated () {
    if (hasAccess([4], this.props.auth.user.UserType)) return
    const { DracarUsable } = this.props.auth.permissions
    if (!DracarUsable) return

    let data = {
      OrderId: this.context.router.params.orderID
    }
    this.props.checkVehicleForCustomers(data).then((res) => {
      let dracarVehicleData = {
        foundVehicle: res.data.VehicleFound,
        customers: res.data.Customers
      }
      this.setState({
        createdNew: false,
        dracarVehicleCheck: dracarVehicleData
      }, () => {
        this.togglePopup('dracarInfoPopup', true)
      })
    })
  }
  checkOrder () {
    if (process.env.NODE_ENV === 'dev') return    // Disable reloading attempts for DEV, for easier debugging
    this.checkOrderTimeoutId = setTimeout(() => {
      if (typeof this.props.order.Id === 'undefined' || typeof this.state.order === 'undefined') {
        window.location.reload()
      }
    }, 10000)
  }
  onCreateEstimationSave (order) {
    if (typeof order !== 'undefined') {
      this.togglePopup('createEstimationPopup', false)
      this.props.onUpdateOrder(order)
    } else {
      this.saveSingleValue('IsEvaluation', true, () => {
        this.togglePopup('createEstimationPopup', false)
        this.props.onUpdateOrder(this.state.order)
      })
    }
  }
  saveWorkcard (e, propName, skipCheck, order) {
    if (this.props.order && this.props.order[propName] !== undefined && this.state.order && this.state.order[propName] !== undefined) {
      if (this.props.order[propName] === this.state.order[propName]) return Promise.resolve()  // No need to post if unchanged.
    }

    if (!order) return this.updateWorkcard(e, propName, skipCheck)
    this.setState({
      order: order
    }, () => {
      return this.updateWorkcard(e, propName, skipCheck)
    })
  }
  updateWorkcard (e, propName, skipCheck) {
    if (typeof e !== 'undefined') e.preventDefault()
    let { order } = this.state
    // Her overføre vi BodyShop RekvNumber til lakerings RekvNumber, hvis det er tomt.
    let LakRekvNumber = order.RekvNumber
    if (order.BodyShopRekvNumber !== '' && propName === 'BodyShopRekvNumber' && (order.RekvNumber === '' || order.RekvNumber === null)) {
      LakRekvNumber = order.BodyShopRekvNumber
    }
    if (['LoosePartsType', 'BodyShopLoosePartsType'].includes(propName) && order.OrderDepartment === 2) {
      if (propName === 'LoosePartsType') { // Set the same loose part type on both
        order.BodyShopLoosePartsType = order.LoosePartsType
      } else {
        order.LoosePartsType = order.BodyShopLoosePartsType
      }
    }
    // BrandName
    let BrandName = order.BrandName
    if (typeof BrandName === 'string' || typeof BrandName === 'number') {
      BrandName = { Id: parseInt(BrandName) }
    }
    // BodyShopTransport
    let BodyShopTransport = order.BodyShopTransport

    if ([order.BodyShopTransport_1_input, order.BodyShopTransport_2_input, order.BodyShopTransport_3_input].includes(false)) {
      BodyShopTransport = 0
    }
    if (order.BodyShopTransport_1_input === true) {
      BodyShopTransport = 1
    } else if (order.BodyShopTransport_2_input === true) {
      BodyShopTransport = 2
    } else if (order.BodyShopTransport_3_input === true) {
      BodyShopTransport = 3
    }
    // Her overføre vi BodyShop Transport over til Lakering i tilfælde af vi er integrationsværksted
    let lakTransport = order.Transport
    // if (this.props.auth.departmentType === 2) {
    if (order.OrderDepartment === 2) {
      lakTransport = BodyShopTransport
    }

    /**
     * If current prop it returns the new value, else null
     * @param {String} prop Actual prop
     * @param {Any} value New value of prop
     */
    const valueOrNull = (prop, value) => {
      if (typeof propName === 'string') {
        return propName === prop ? value : null
      }
      return value
    }

    /**
     * If dependent props has propName it returns the new value, else null
     * @param {Array<String>} props Dependent props
     * @param {Any} value New value of prop
     */
    const dependentValueOrNull = (props, value) => {
      if (typeof propName === 'string') {
        return props.includes(propName) ? value : null
      }
      return value
    }

    const DELIVERY_PROPS = [ 'PickupTimes', 'ProductionTimes', 'DeliveryTimes', 'BodyShopPickupTime', 'BodyShopProductionTime', 'BodyShopDeliveryTime', 'updateDelivery', 'CommentShowToCustomer', 'CommentApplyToInvoice' ]
    const TRANSPORT_PROPS = [ 'Transport', 'BodyShopTransport_1_input', 'BodyShopTransport_2_input', 'BodyShopTransport_3_input', 'LoosePartsType', 'BodyShopLoosePartsType' ]

    let data = {
      OrderID: order.Id,
      Identification: {
        IsDirty: false,
        OrderType: valueOrNull('OrderType', order.OrderType),
        RekvNumber: dependentValueOrNull([ 'RekvNumber', 'BodyShopRekvNumber' ], LakRekvNumber),
        BodyShopRekvNumber: valueOrNull('BodyShopRekvNumber', order.BodyShopRekvNumber),
        IsBodyShopOrder: dependentValueOrNull([ 'IsBodyShopOrder', 'IsPaintOrder' ], order.IsBodyShopOrder),
        IsPaintOrder: dependentValueOrNull([ 'IsBodyShopOrder', 'IsPaintOrder' ], order.IsPaintOrder),
        Extent: valueOrNull('Extent', null),
        BodyShopSelectedStatus: valueOrNull('BodyShopSelectedStatus', Number('' + order.BodyShopSelectedStatus))
      },
      Notes: {
        IsDirty: false,
        Notes: order.Notes
      },
      BodyShopDelivery: {
        IsDirty: false,
        Pickup: dependentValueOrNull(DELIVERY_PROPS, order.BodyShopPickupTime),
        ProductionDate: dependentValueOrNull(DELIVERY_PROPS, order.BodyShopProductionTime),
        Delivery: dependentValueOrNull(DELIVERY_PROPS, order.BodyShopDeliveryTime),
        Transport: dependentValueOrNull(TRANSPORT_PROPS, BodyShopTransport),
        LoosePartsType: dependentValueOrNull(TRANSPORT_PROPS, '' + order.BodyShopLoosePartsType === 'true'),
        HasPickupAltLocation: dependentValueOrNull([ 'HasBodyShopPickupAltLocation', 'BodyShopPickupAltLocationId', 'BodyShopPickupAltLocationComment' ], order.HasBodyShopPickupAltLocation),
        PickupAltLocationId: dependentValueOrNull([ 'HasBodyShopPickupAltLocation', 'BodyShopPickupAltLocationId' ], Number('' + order.BodyShopPickupAltLocationId)),
        PickupAltLocationComment: valueOrNull('BodyShopPickupAltLocationComment', order.BodyShopPickupAltLocationComment),
        HasDeliveryAltLocation: dependentValueOrNull([ 'HasBodyShopDeliveryAltLocation', 'BodyShopDeliveryAltLocationId', 'BodyShopDeliveryAltLocationComment' ], order.HasBodyShopDeliveryAltLocation),
        DeliveryAltLocationId: dependentValueOrNull([ 'HasBodyShopDeliveryAltLocation', 'BodyShopDeliveryAltLocationId' ], Number('' + order.BodyShopDeliveryAltLocationId)),
        DeliveryAltLocationComment: valueOrNull('BodyShopDeliveryAltLocationComment', order.BodyShopDeliveryAltLocationComment),
        EstimatedProcessTimeInMin: valueOrNull('EstimatedProcessTimeShown', order.EstimatedProcessTime)
      },
      Delivery: {
        IsDirty: false,
        Delivery: dependentValueOrNull(DELIVERY_PROPS, order.Delivery),
        ProductionDate: dependentValueOrNull(DELIVERY_PROPS, order.ProductionDate),
        Pickup: dependentValueOrNull(DELIVERY_PROPS, order.Pickup),
        Transport: dependentValueOrNull(TRANSPORT_PROPS, lakTransport),
        LoosePartsType: dependentValueOrNull(TRANSPORT_PROPS, '' + order.LoosePartsType === 'true'),
        DeliveryAltLocationId: dependentValueOrNull([ 'HasDeliveryAltLocation', 'DeliveryAltLocationId' ], Number('' + order.DeliveryAltLocationId)),
        PickupAltLocationId: dependentValueOrNull([ 'HasPickupAltLocation', 'PickupAltLocationId' ], Number('' + order.PickupAltLocationId)),
        SuppressSMS: valueOrNull('SuppressSMS', order.SuppressSMS),
        LTW: valueOrNull('LTW', order.LTW),
        LTWIdCode: dependentValueOrNull([ 'LTW', 'LTWIdCode' ], order.LTWIdCode),
        DeliveryChangeReason: dependentValueOrNull(DELIVERY_PROPS, order.DeliveryChangeReason),
        DeliveryChangeComment: dependentValueOrNull(DELIVERY_PROPS, order.DeliveryChangeComment),
        DateChangeReason: dependentValueOrNull(DELIVERY_PROPS, order.DateChangeReason),
        HasPickupAltLocation: dependentValueOrNull([ 'HasPickupAltLocation', 'PickupAltLocationId', 'PickupAltLocationComment' ], order.HasPickupAltLocation),
        HasDeliveryAltLocation: dependentValueOrNull([ 'HasDeliveryAltLocation', 'DeliveryAltLocationId', 'DeliveryAltLocationComment' ], order.HasDeliveryAltLocation),
        PickupAltLocationComment: valueOrNull('PickupAltLocationComment', order.PickupAltLocationComment),
        DeliveryAltLocationComment: valueOrNull('DeliveryAltLocationComment', order.DeliveryAltLocationComment),
        DeliveryDatesHasValue: dependentValueOrNull(DELIVERY_PROPS, true),
        CommentShowToCustomer: dependentValueOrNull(DELIVERY_PROPS, order.CommentShowToCustomer),
        CommentApplyToInvoice: dependentValueOrNull(DELIVERY_PROPS, order.CommentApplyToInvoice)
      },
      Color: {
        IsDirty: false,
        ColorControlIncluded: valueOrNull('ColorControlIncluded', order.ColorControlIncluded),
        Color: valueOrNull('Color', order.Color),
        ColorCode: valueOrNull('ColorCode', order.ColorCode),
        ColorVariant: valueOrNull('ColorVariant', order.ColorVariant),
        ColorIsReady: valueOrNull('ColorIsReady', order.ColorIsReady),
        ColorAmount: valueOrNull('ColorAmount', order.ColorAmount)
      },
      Vehicle: {
        IsDirty: false,
        RegNumber: dependentValueOrNull([ 'updateVehicle', 'RegNumber' ], order.RegNumber),
        BrandNameHasValue: dependentValueOrNull([ 'updateVehicle', 'BrandName' ], true),
        BrandName: dependentValueOrNull([ 'updateVehicle', 'BrandName' ], BrandName),
        Model: dependentValueOrNull([ 'updateVehicle', 'Model' ], order.Model),
        Doors: dependentValueOrNull([ 'updateVehicle', 'Doors' ], order.Doors),
        RegistrationDate: dependentValueOrNull([ 'updateVehicle', 'RegistrationDate' ], order.RegistrationDate),
        ChassisNumber: dependentValueOrNull([ 'updateVehicle', 'ChassisNumber' ], order.ChassisNumber),
        DistanceDriven: valueOrNull('DistanceDriven', order.DistanceDriven)
      },
      Customer: {
        IsDirty: false,
        CustomerName: valueOrNull('CustomerName', order.CustomerName),
        Contact: valueOrNull('Contact', order.Contact),
        ContactPhone: valueOrNull('ContactPhone', order.ContactPhone),
        IsReferredIn: valueOrNull('IsReferredIn', order.IsReferredIn),
        IsReferredOut: valueOrNull('IsReferredOut', order.IsReferredOut),
        CreatedBy: valueOrNull('CreatedBy', order.CreatedBy),
        CreationDate: valueOrNull('CreationDate', order.CreationDate),
        HasRequestedCarRental: valueOrNull('HasRequestedCarRental', order.HasRequestedCarRental),
        CarRentalId: dependentValueOrNull([ 'CarRentalId', 'HasCarRental' ], order.CarRentalId),
        CarOwnerName: valueOrNull('CarOwnerName', order.CarOwnerName),
        CarOwnerLastName: valueOrNull('CarOwnerLastName', order.CarOwnerLastName),
        CarOwnerAddress: valueOrNull('CarOwnerAddress', order.CarOwnerAddress),
        CarOwnerZipCode: valueOrNull('CarOwnerZipCode', order.CarOwnerZipCode),
        CarOwnerCity: valueOrNull('CarOwnerCity', order.CarOwnerCity),
        CarOwnerPhones: valueOrNull('CarOwnerPhones', order.CarOwnerPhones),
        CarOwnerMail: valueOrNull('CarOwnerMail', order.CarOwnerMail),
        InsuranceCompanyId: valueOrNull('InsuranceCompanyId', order.InsuranceCompanyId),
        InsuranceDamageNr: valueOrNull('InsuranceDamageNr', order.InsuranceDamageNr)
      },
      SpareParts: {
        IsDirty: false,
        HasSpareParts: valueOrNull('HasSpareParts', order.HasSpareParts)
      }
    }
    var groups = {
      Identification: [
        'BodyShopRekvNumber', 'OrderType', 'IsBodyShopOrder', 'IsPaintOrder', 'RekvNumber', 'BodyShopSelectedStatus'],
      BodyShopDelivery: [
        'BodyShopTransport_1_input', 'BodyShopTransport_2_input', 'BodyShopTransport_3_input', 'Transport',
        'HasBodyShopPickupAltLocation', 'BodyShopPickupAltLocationId', 'BodyShopPickupAltLocationComment',
        'HasBodyShopDeliveryAltLocation', 'BodyShopDeliveryAltLocationId', 'BodyShopDeliveryAltLocationComment',
        'BodyShopPickupTime', 'BodyShopProductionTime', 'BodyShopDeliveryTime', 'LoosePartsType', 'BodyShopLoosePartsType', 'EstimatedProcessTimeShown'],
      Delivery: [
        'LTW', 'LTWIdCode', 'Transport', 'BodyShopTransport_1_input', 'BodyShopTransport_2_input', 'BodyShopTransport_3_input',
        'HasPickupAltLocation', 'PickupAltLocationId', 'PickupAltLocationComment',
        'HasDeliveryAltLocation', 'DeliveryAltLocationId', 'DeliveryAltLocationComment',
        'PickupTimes', 'ProductionTimes', 'DeliveryTimes', 'LoosePartsType', 'BodyShopLoosePartsType', 'updateDelivery', 'SuppressSMS'],
      Color: [
        'ColorControlIncluded', 'Color', 'ColorCode', 'ColorVariant', 'ColorIsReady', 'ColorAmount'],
      Vehicle: [
        'RegNumber', 'BrandName', 'Model', 'Doors', 'RegistrationDate', 'ChassisNumber', 'updateVehicle', 'DistanceDriven'],
      Customer: [
        'InsuranceCompanyId', 'Contact', 'ContactPhone', 'CarOwnerName', 'CarOwnerLastName', 'CarOwnerAddress', 'CarOwnerZipCode', 'CarOwnerCity',
        'CarOwnerPhones', 'CarOwnerMail', 'HasRequestedCarRental', 'HasCarRental', 'CarRentalId', 'InsuranceDamageNr'],
      SpareParts: [
        'HasSpareParts']
    }
    let foundDirty = false
    Object.keys(groups).map((key) => { // same key for groups and data makes this a short one
      if (groups[key].includes(propName)) foundDirty = data[key].IsDirty = true
    })
    // I tilfælde af vi ikke kan finde det korrekte segment at gemme, så gemmer vi det hele som før.
    if (!foundDirty) Object.keys(groups).map((key) => { data[key].IsDirty = true })

    // Set loading spinner
    // this.props.triggerPopupActionBG(true)
    // Save workcard order
    return this.props.saveOrder(data).then((res) => {
      if (/\/orders\/\d{6,}/.test(this.props.router.location.pathname)) {
        // Only change if still on workcard
        this.props.setPageTitle(makeOrderPageTitleObject(res.data))
      }

      this.props.onUpdateOrder(res.data)
      let priceChanged = res.data.PriceWasChanged
      // Remove spinner
      if (!this.state.createEstimationPopup.show) this.props.triggerPopupActionBG(false)
      // Toastr
      // let message = translation('13403')
      // if (res.data.IsDraft) message = translation('2261')
      // window.toastr.success(message, translation('13424'))
      if (priceChanged) {
        window.toastr.info(translation('2244'))
        this.setState({
          loosepartChangeConfirmDialogOpen: true
        }, () => {
          // console.log('PriceChange', this.props)
          if (!this.state.priceInformation) {
            this.getPriceInformations()
          }
        })
      }
      if (data.BodyShopDelivery.IsDirty) this.renderCarRentalList()
      return res
    }, (err) => {
      // Remove spinner
      // this.props.triggerPopupActionBG(false)

      // console.log('err', err.response.data)
      let data = err.response.data
      if (data.Errors !== undefined && data.Errors !== null && data.Errors.length > 0) {
        for (let i = 0; i < data.Errors.length; i++) {
          window.toastr.error(translation(data.Errors[i].DictionaryKey), translation('216'))
          this.props.onUpdateOrder(data)
        }
      } else {
        // Toastr
        window.toastr.error(translation('13404'), translation('216'))
        return null
      }
    })
  }

  bookOrder (e, BodyShop = false, BookAll = false, DoNotRoute = false) {
    const wait = (until, doAfter) => {
      if (until() === true) return doAfter()
      setTimeout(() => {
        wait(until, doAfter)
      }, 100)
    }
    wait(() => { return this.state.isSaving === false || this.state.isSaving === undefined }, () => {
      // Set loading spinner
      this.props.triggerPopupActionBG(true)
      let { order } = this.state
      let routeItem = window.LocalstorageStack.findFirst(['/workscreen', '/orders', '/CarRentals/Overview'])

      this.setState({ updating: true }, () => {
        this.saveWorkcard(e).then((res) => {
          const bookingOptions = { bookingDestination: this.props.bookingDestination, assignments: this.props.assignments }
          // console.log('Book order -> booking options: ', bookingOptions)
          let data = {
            OrderId: order.Id,
            Transport: parseInt(order.Transport),
            BrandName: order.BrandName,
            Model: order.Model,
            BookOnlyBodyShopOrder: BodyShop === true,
            Assignments: bookingOptions.assignments
          }
          this.props.triggerPopupActionBG(true)
          this.props.bookOrder(data).then((res) => {
            // Update order
            // Toastr
            // window.toastr.success(translation('13416'), translation('13424'))
            // Remove spinner
            this.props.triggerPopupActionBG(false)
            this.setState({ updating: false })
            // Go back
            if (this.props.auth.departmentType !== 1 || !DoNotRoute) {
              let routeParams = '?orderid=' + order.Id
              if (bookingOptions.bookingDestination) {
                routeParams += '&destination=' + bookingOptions.bookingDestination
              }
              if (routeItem === null) {
                this.props.router.replace('/orders' + routeParams)
              } else {
                this.props.router.replace(routeItem.pathname + routeParams)
              }
            }
            this.props.onUpdateOrder(res.data.Order)
          }, (err) => {
            this.setState({ updating: false })
            if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
              let errors = err.response.data.Errors
              let errorText = ''
              errors.map((item) => {
                if (item.DictionaryKey !== 0) errorText += `<br />${translation(item.DictionaryKey)}<br />`
              })
              // Toastr
              window.toastr.error(translation(errorText), translation('216'))
            } else {
              // Toastr
              window.toastr.error(translation(13417), translation('216'))
            }
            this.props.triggerPopupActionBG(false)
          })
        })
      })
    })
  }

  onChange (e) {
    e.persist()
    let value = e.target.value
    if (e.target.type === 'checkbox') value = e.target.checked
    // console.log('onCHange wokacrsd', { e, value })
    this.saveSingleValue(e.target.name, value, () => {
      // console.log(e.target.name, value, typeof value, e.target.type)
      if (['checkbox', 'select-one', 'radio'].includes(e.target.type)) {
        this.saveWorkcard(undefined, e.target.name, undefined).then(() => {
          if (['Transport', 'BodyShopTransport_1_input', 'BodyShopTransport_2_input', 'BodyShopTransport_3_input'].includes(e.target.name)) {
            if (typeof this.refs.price1 !== 'undefined') this.refs.price1.getWrappedInstance().getPrices()
            if (typeof this.refs.price2 !== 'undefined') this.refs.price2.getWrappedInstance().getPrices()
          }
        })
      }
    })
  }
  saveSingleValue (name, value, callback) {
    this.setState({
      order: {
        ...this.state.order,
        [name]: value
      }
    }, () => { if (callback) callback() })
  }
  onBlur (e) {
    e.persist()
    this.setState({ isSaving: true })
    let value = e.target.value
    if (e.target.type === 'checkbox') value = e.target.checked
    this.saveSingleValue(e.target.name, value, () => {
      this.saveWorkcard(undefined, e.target.name, undefined).then(() => {
        this.setState({ isSaving: false })
      })
    })
  }

  onCarOwnerBlur (e) {
    e.persist()
    this.setState({ isSaving: true })
    let value = e.target.value
    this.saveSingleValue(e.target.name, value, () => {
      this.saveWorkcard(undefined, e.target.name, undefined).then(() => {
        console.log('onCarOwnerBlur', e.target.name, e.target.value)
        EventEmitter.emit('UPDATE_CAROWNER')
        this.setState({ isSaving: false })
      })
    })
  }

  onRegBlur (e) {
    e.persist()
    let value = e.target.value
    let name = e.target.name
    if (value !== null && value.trim() !== '' && (hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10))) {
      this.props.getOrderVehicleData(value, name).then((res) => {
        this.setState({
          order: {
            ...this.state.order,
            [e.target.name]: value,
            RegNumber: res.data.RegNr,
            Model: res.data.Model || '',
            BrandName: res.data.BrandNameId.toString() || '0',
            ChassisNumber: res.data.ChassisNumber || '',
            RegistrationDate: res.data.RegistrationDate || ''
          }
        }, () => {
          this.saveWorkcard(undefined, 'updateVehicle', undefined)
          if (res.data.DictionaryKey !== 0) {
            // Toastr
            window.toastr.info(translation(res.data.DictionaryKey))
          }
        })
      }, (err) => {
        this.saveSingleValue(e.target.name, value, this.saveWorkcard)
        // Toastr
        window.toastr.error(translation(err.response.data.DictionaryKey), translation('216'))
      })
    } else {
      this.saveSingleValue(e.target.name, value, this.saveWorkcard)
    }
  }

  onTimeSpanBlur (e) {
    let name = e.target.name
    let value = e.target.value
    if (e.target.currentFormat === -1 && this.state.order.EstimatedProcessTime) {  // (-1 = invalid format)
      window.toastr.error(translation(16837), translation('216'))
    } else {
      // Estimated process time.
      let estimatedProcessTime = value === null ? null : value.decimal
      if (estimatedProcessTime === null || Number.isNaN(estimatedProcessTime) || estimatedProcessTime === 0) {
        estimatedProcessTime = null
      } else {
        estimatedProcessTime *= 60
      }
      this.setState({
        order: {
          ...this.state.order,
          EstimatedProcessTime: estimatedProcessTime
        },
        isSaving: true
      }, () => {
        this.saveWorkcard(undefined, name, undefined).then(() => {
          this.setState({ isSaving: false })
        })
      })
    }
  }

  // showNotePopup(item) {
  //   console.log('here')
  //   let note = { Note: '', NoteTypeID: 0, OrderID: this.state.order.Id, ApplyToInvoice: false }
  //   if (typeof item !== 'undefined') {
  //     if (typeof item.OrderID !== 'undefined') {
  //       note = item
  //     }
  //   }
  //   console.log('note ', note)
  //   this.props.triggerPopup(!this.state.notePopup.showNotePopup)
  //   this.setState({
  //     notePopup: {
  //       showNotePopup: !this.state.notePopup.showNotePopup,
  //       note: note
  //     }
  //   }, () => console.log('showNote', this.state.notePopup))
  // }

  renderDracar () {
    const { DracarUsable } = this.props.auth.permissions
    const { order } = this.state

    if (!DracarUsable || !DracarAllowOrderTypes.includes(order.OrderType)) return null

    return <Dracar order={this.state.order} />
  }

  renderNotes ($type = 'box', $screen = '') {
    let notes = this.state.order.Notes
    // Update note
    const onUpdateNote = (data) => {
      let newData = { ...this.state.order }
      const index = newData.Notes.findIndex((note) => note.NoteID === data.NoteID)
      if (index === -1) newData.Notes.push(data)
      else newData.Notes[index] = data
      this.props.onUpdateOrder(newData)
    }
    // Delete note
    const deleteNote = (item) => {
      this.setState({
        confirmDelete: {
          open: true,
          NoteID: item.NoteID
        }
      })
    }
    // Render each note
    const renderNote = (item, index) => {
      if (!item.IsMine && !hasSubscriptionPermission(this.props.auth, 10)) return null
      let editIcon, customerIcon, deleteIcon, invoiceIcon, editedText

      if (this.props.auth.user.CustomerId === '-1') {
        invoiceIcon = <div className='hint--top' aria-label={translation('14835')}><img src='/images/svgs/invoice/Total_price.svg' className='renderIcons' /></div>
      // Customer icon
        if (!item.CreatedByCustommer && item.ShowToCustomer) {
          customerIcon = <div className='hint--top' aria-label={translation('2157')}><img src='/images/icons/Customer_16.png' /></div>
        }
      }
      // Delete icon + edit icon
      if (item.IsMine && (this.props.auth.user.CustomerId === '-1' || this.props.order.IsDraft) && item.SourceID !== 26) {
        editIcon = <div className='hint--top' aria-label={translation('13357')}><img src='/images/icons/edit_16.png' onClick={() => showNotePopup(item)} /></div>
        if (item.SourceID !== 26 && !this.props.order.IsReferredIn && !this.props.order.IsReferredOut) { // Can't delete notes if order is referred
          deleteIcon = <div className='hint--top' aria-label={translation('2156')}><img src='/images/icons/Delete_16.png' onClick={() => deleteNote(item)} /></div>
        }
      }

      if (item.IsEdited) {
        editedText = <Label>{16853}</Label>
      }

      return (
        <div key={index} className='workcard-note'>
          <Grid cols={[1, 'max-content']} align='start'>
            <div>
              <UserInfo user={item.UserInfo} />
              <Inline spacing={[0]}>
                {renderFullDate(item.NoteDate)}
                {editedText}
              </Inline>
            </div>
            <Inline spacing={[0]}>
              {this.props.disabled !== true && editIcon}
              {customerIcon}
              {item.ApplyToInvoice === true && invoiceIcon}
              {this.props.disabled !== true && deleteIcon}
            </Inline>
          </Grid>
          <div>{translation(item.SourceDictionaryKey)}: {item.Note}</div>
          {item.ShareType > 0 && (<Label>
            {translation('17861')}
            {getOrderNoteShareString(item.ShareType)}
          </Label>)}
        </div>
      )
    }
    // Show note popup
    const showNotePopup = (item) => {
      let note = { Note: '', NoteTypeID: 0, OrderID: this.state.order.Id, ApplyToInvoice: false }
      if (typeof item !== 'undefined') {
        if (typeof item.OrderID !== 'undefined') {
          note = item
        }
      }
      this.props.triggerPopup(!this.state.notePopup.showNotePopup)
      this.setState({
        notePopup: {
          showNotePopup: !this.state.notePopup.showNotePopup,
          note: note
        }
      }, () => console.log('showNote', this.state.notePopup))
    }
    // console.log('type - data ', $type)
    // console.log('state ', this.state.notePopup.showNotePopup)

    let nrOfComments = notes.length// + dateChangeComments.length
    if ($type === 'data') {
      return (
        <Panel dataCol='notes'>
          <NotesModal
            show={this.state.notePopup.showNotePopup}
            onClose={showNotePopup}
            note={this.state.notePopup.note}
            onSuccess={onUpdateNote.bind(this)}
            order={this.state.order} />
          <div className='title'>{translation('14834')} ({nrOfComments})</div>
          <div className='notes_inner'>
            {notes.map(renderNote)}
          </div>
          {this.props.disabled !== true && (
            <button onClick={showNotePopup} className='button full primary'><img src='/images/icons/circle_plus22-black.png' />{translation('75')}</button>
          )}
        </Panel>
      )
    } else {
      if ($screen !== '') {
        return (
          <Panel title={`${translation('14834')} (${nrOfComments})`} dataCol='notes'>
            <NotesModal
              show={this.state.notePopup.showNotePopup}
              onClose={showNotePopup}
              note={this.state.notePopup.note}
              onSuccess={onUpdateNote.bind(this)}
              order={this.state.order}
            />
            {notes.map(renderNote)}
            {this.props.disabled !== true && (
              <Button style='link' onClick={showNotePopup} labelText={translation('75')} />
            )}
          </Panel>
        )
      } else {
        return (
          <Panel title={`${translation('14834')} (${nrOfComments})`} dataCol='notes'>
            <NotesModal
              show={this.state.notePopup.showNotePopup}
              onClose={showNotePopup}
              note={this.state.notePopup.note}
              onSuccess={onUpdateNote.bind(this)}
              order={this.state.order}
            />
            {notes.map(renderNote)}
            {this.props.disabled !== true && (
              <Button style='link' onClick={showNotePopup} labelText={translation('75')} />
            )}
          </Panel>
        )
      }
    }
  }

  renderCarRentalList () {
    let orderId = this.context.router.params.orderID // Can't get orderId from state or props...
    this.props.GetSimpleCarRentals(0, orderId).then((res) => {
      let data = [
        { Id: 0, Name: translation('14790') },
        ...res.data.filter(car => car.Active)
      ]
      this.setState({ carrental: data })
    })
  }
  renderBodyShopTransport () {
    let isLoosePart = this.state.order.BodyShopTransport === 2 || this.state.order.BodyShopTransport === '2'
    let isPickup = this.state.order.HasBodyShopPickupAltLocation === true
    let isDelivery = this.state.order.HasBodyShopDeliveryAltLocation === true
    let isCustomer = hasAccess([4], this.props.auth.user.UserType)
    let isReferredIn = this.state.order.IsReferredIn
    let currentShopCanAssignRentalCar = this.state.order.CurrentShopCanAssignRentalCar
    // Transport formatter to add icons?
    const transportFormatter = (val, listItemValName) => {
      let name = (typeof val === 'number') ? '' : val.Name
      if (name === '') {
        this.props.transport.map((v, index) => {
          if (v.Id === val) {
            name = v.Name
          }
        })
      }
      return <span>{translation(name)}</span>
    }
    const renderList = (inputName, name, value) => {
      let list = [...this.state.order.CustomerClients]
      let data = [
        { CustomerClientId: 0, Name: translation('227'), Address: '', ZipCode: '', City: '', CustomerId: 0, DisplayVal: translation('227') }
      ]

      if (isReferredIn) {
        let customerClient = this.state.order[value.replace('Id', '')]
        if (customerClient !== null) data.push(customerClient)
      } else {
        list.map(customerClient => data.push(customerClient))
      }

      data.map((val, key) => {
        val.DisplayVal = val.Name
        if (val.Address !== '') val.DisplayVal += ', ' + val.Address
      })
      return this.getInputRender(inputName, value, undefined, 'list', data, ['CustomerClientId', 'DisplayVal'])
    }

    return (
      <div data-col='bodyshoptransport'>
        <PanelHeader text={translation('13373')} />
        <div className='information'>
          {this.getInputRender('14830', 'IsBodyShopOrder', undefined, 'checkbox')}
          {/* hasSubscriptionPermission(this.props.auth, 10) && (this.getInputRender('157', 'BodyShopPickupTime', renderFullDate))}
          {hasSubscriptionPermission(this.props.auth, 20) && (this.getInputRender('13394', 'BodyShopProductionTime', renderFullDate))}
    {hasSubscriptionPermission(this.props.auth, 10) && (this.getInputRender('193', 'BodyShopDeliveryTime', renderFullDate)) */}
          {hasSubscriptionPermission(this.props.auth, 10) && <BookingTimes OrderId={this.state.order.Id} ShowLeadTime FromBody onUpdated={this.onBookingTimesUpdated} />}
          <TimeSpan name='EstimatedProcessTimeShown' value={this.state.order.EstimatedProcessTimeShown || ''} labelText={16835} onBlur={this.onTimeSpanBlur} onChange={this.onChange} disabled={!this.state.order.CanEditEstimatedProcessTime} />
          {hasSubscriptionPermission(this.props.auth, 10) && (this.getInputRender('80', 'BodyShopRekvNumber'))}
          {hasSubscriptionPermission(this.props.auth, 20) && this.getInputRender('983', 'SuppressSMS', undefined, 'checkbox')}

          {this.getInputRender('26', 'BodyShopTransport', transportFormatter, 'list', this.props.transport, ['Id', 'Name'])}
          {isLoosePart && this.getInputRender('13395', 'BodyShopLoosePartsType', undefined, 'list', this.props.loosePartType, ['Id', 'Name'])}

          {this.renderTransportText()}
          <Divider noLine />
          {this.getInputRender('14859', 'HasRequestedCarRental', undefined, 'checkbox')}
          {this.state.order.CarRentalAssignmentReset && <div className='carRentalWarning'>{translation(16823)}</div>}
          {this.state.order.HasCarRental && this.state.order.IsUsingAdvancedCarRental && <CarRentalAssignmentList items={this.state.order.CarRentalAssignments} />}
          {!isCustomer && <Button id='carRentalAdvancedBtn' noSubmit style='secondary' labelText={translation('16769')} onClick={this.togglePopup.bind(this, 'handleCarRentalPopup')} disabled={!currentShopCanAssignRentalCar || !this.state.order.HasRequestedCarRental} />}
          {!isCustomer && this.state.order.HasCarRentalNotAlternative && this.props.auth.carRentalSystem === CarRentalSystemTypes.NONE && currentShopCanAssignRentalCar && <CarRentalContract order={this.state.order} onUpdateOrder={this.props.onUpdateOrder} />}
          {hasSubscriptionPermission(this.props.auth, 20) && this.getInputRender('14764', 'HasBodyShopPickupAltLocation', undefined, 'checkbox')}
          {hasSubscriptionPermission(this.props.auth, 20) && isPickup && renderList(translation('713'), '25', 'BodyShopPickupAltLocationId')}
          {hasSubscriptionPermission(this.props.auth, 20) && isPickup && this.getInputRender('14769', 'BodyShopPickupAltLocationComment')}
          {hasSubscriptionPermission(this.props.auth, 20) && this.getInputRender('14765', 'HasBodyShopDeliveryAltLocation', undefined, 'checkbox')}
          {hasSubscriptionPermission(this.props.auth, 20) && isDelivery && renderList(translation('714'), '25', 'BodyShopDeliveryAltLocationId')}
          {hasSubscriptionPermission(this.props.auth, 20) && isDelivery && this.getInputRender('14770', 'BodyShopDeliveryAltLocationComment')}
        </div>
      </div>
    )
  }

  renderBookExternalLak () {
    const { order } = this.props
    // console.log('render booking external lak')
    let bookingStopped = order.IsAgreementForsiCreated && !order.IsEvaluation
    let evaluationStopped = (!order.IsEvaluation || (order.IsEvaluation && !order.IsEvaluated)) && order.CustomerWPEvaluationRequired && order.IsAgreementOrder
    let evaluationRejected = order.IsEvaluation && !order.IsEvaluated && order.IsEvaluationRejected && order.CustomerWPEvaluationRequired && order.IsAgreementOrder
    let bookingButtonClass = 'BookPaintBTN button primary full'
    let bookingButtonLabel = ''
    let bookingStoppedLabel = ''
    let disabled = this.state.updating || order.IsReferredOut

    if (bookingStopped) {
      bookingButtonClass += ' disabled hint--left'
      bookingButtonLabel += ' ' + translation('13568')
      bookingStoppedLabel = translation('13568')
    } else if (evaluationStopped) {
      const evaluationRequiredTxt = order.IsEvaluation ? translation('13038') : translation('15177')
      bookingButtonClass += ' disabled hint--left BookPaintBTN--small'
      bookingButtonLabel += ' ' + evaluationRequiredTxt
      bookingStoppedLabel = evaluationRequiredTxt
    }
    const bookingStoppedToast = () => {
      window.toastr.error(order.IsEvaluation ? translation('13038') : translation('15177'))
      if (!order.IsEvaluation && !order.IsEvaluated) {
        this.togglePopup.bind(this, 'createEstimationPopup')()
      }
    }
    // if (this.props.auth.departmentType === 1) {
    if (order.OrderDepartment === 1 && order.HasAvailablePaintPartner) {
      if (order.PaintIsDraft) {
        if (order.NeedReferredApprove) {
          // Order has been referred in but not yet approved. Prevent booking.
          return (
            <div className='alert-h4-text'>{translation('18096')}</div>
          )
        } else {
          return (
            <Inline fillChildNum={[1]} block>
              {(bookingStopped || evaluationStopped) && (
                <div className='left hint--left stopBookingIcon' aria-label={bookingStoppedLabel}>
                  <img src={'/images/icons/Stop-31.png'} onClick={bookingStopped || evaluationRejected ? this.togglePopup.bind(this, 'createEstimationPopup') : bookingStoppedToast} />
                </div>
              )}
              {order.PaintIsDraft && hasSubscriptionPermission(this.props.auth, 0, 2) && (
                <Button
                  style='link'
                  spacing={0}
                  className={bookingButtonClass}
                  aria-label={bookingButtonLabel}
                  disabled={disabled}
                  onClick={bookingStopped || evaluationRejected ? this.togglePopup.bind(this, 'createEstimationPopup') : evaluationStopped ? bookingStoppedToast : this.bookOrder.bind(this, undefined, false, false, true)}
                >
                  {translation('13384')}
                </Button>
              )}
            </Inline>
          )
        }
      } else {
        return (
          <LabelWrapper
            labelText={translation('13532')}
            helpText={translation('13011') + ': ' + this.props.order.PublishedBy + '\n' + translation('65') + ': ' + this.props.order.PublishedByShopName + '\n' + translation('388') + ': ' + renderFullDate(this.props.order.PublishDate) + '\n' + translation('1052') + ': ' + this.props.order.PublishedByMail + '\n' + translation('38') + ': ' + this.props.order.PublishedByMobile}
          />
        )
      }
    }
  }

  renderTransport ($type = 'box') {
    let isLoosePart = false
    let isPickup = false
    let isDelivery = false
    if (this.state.order.HasPickupAltLocation === true) isPickup = true
    if (this.state.order.HasDeliveryAltLocation === true) isDelivery = true
    if ([2, '2'].includes(this.state.order.Transport)) isLoosePart = true
    // Transport formatter to add icons?
    const transportFormatter = (val, listItemValName) => {
      let name = (typeof val === 'number') ? '' : val.Name
      if (name === '') {
        this.props.transport.map((v, index) => {
          if (v.Id === val) {
            name = v.Name
          }
        })
      }
      return <span>{translation(name)}</span>
    }

    const renderList = (inputName, name, value) => {
      let list = [...this.state.order.CustomerClients]
      let data = [
        { CustomerClientId: 0, Name: translation('227'), Address: '', ZipCode: '', City: '', CustomerId: 0, DisplayVal: translation('227') }
      ]

      if (this.props.auth.user.DepartmentType === 1 && this.state.order.IsReferredOut) {
        let customerClient = this.state.order[value.replace('Id', '')]
        if (customerClient !== null) data.push(customerClient)
      } else {
        list.map(customerClient => data.push(customerClient))
      }

      data.map((val, key) => {
        val.DisplayVal = val.Name
        if (val.Address !== '') val.DisplayVal += ', ' + val.Address
      })
      return this.getInputRender(inputName, value, undefined, 'list', data, ['CustomerClientId', 'DisplayVal'])
    }

    let canEditTimes = (this.state.order.PaintIsDraft && this.props.auth.departmentType === 1 && !this.state.order.IsReferredOut) || this.props.auth.departmentType !== 1

    const renderPanel = (content) => {
      return (
        <Panel title={translation('13373')} dataCol='transport'>
          {content}
        </Panel>
      )
    }

    const renderHeader = (content) => {
      return (
        <div data-col='transport'>
          <PanelHeader text={translation('13373')} />
          {content}
        </div>
      )
    }

    const renderContent = () => {
      return (
        <div>
          {this.props.auth.departmentType === 1 && !this.props.order.HasAvailablePaintPartner && (
            <div className='information'>
              {$type === 'data' && this.props.auth.user.UserType !== 4 && this.getInputRender('14829', 'IsPaintOrder', undefined, 'checkbox')}
            </div>
          )}
          {(this.props.auth.departmentType !== 1 || this.props.order.HasAvailablePaintPartner) && (
            <div className='information'>
              {$type === 'data' && this.props.auth.user.UserType !== 4 && this.getInputRender('14829', 'IsPaintOrder', undefined, 'checkbox')}
              {/* (hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && canEditTimes && this.getInputRender('14814', 'Pickup', renderFullDate)}
              {(hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && !canEditTimes && <OrderDate onUpdateOrder={() => { }} saveWorkcard={() => { }} name={'Pickup'} translateKey={'14814'} formatter={renderFullDate} disabled />}
              {(hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && !canEditTimes && <BookingTimes OrderId={this.state.order.Id} FromPaint />}
              {hasSubscriptionPermission(this.props.auth, 20) && this.props.auth.departmentType !== 1 && this.getInputRender('13394', 'ProductionDate', renderFullDate)}
              {(hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && canEditTimes && this.getInputRender('14815', 'Delivery', renderFullDate)}
              {(hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && !canEditTimes && <OrderDate onUpdateOrder={() => { }} saveWorkcard={() => { }} name={'Delivery'} translateKey={'14815'} formatter={renderFullDate} disabled /> */}
              {(hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && <BookingTimes OrderId={this.state.order.Id} FromPaint onUpdated={this.onBookingTimesUpdated} />}

              {canEditTimes && this.state.order.OrderDepartment === 1 && (this.getInputRender('26', 'Transport', transportFormatter, 'list', this.props.transport, ['Id', 'Name']))}
              {!canEditTimes && <RadioList title={'26'} name={'Transport'} formatter={transportFormatter}
                value={'' + this.state.order.Transport} onChange={() => { }}
                listItems={this.removeLoosePart('Transport', this.props.transport)} listItemValName={['Id', 'Name']} disabled translate />}
              {(this.state.order.OrderDepartment === 0 || (this.state.order.OrderDepartment === 2 && !this.state.order.IsBodyShopOrder)) && (this.getInputRender('26', 'Transport', transportFormatter, 'list', this.props.transport, ['Id', 'Name']))}
              {$type !== 'data' && this.renderTransportText()}
              {isLoosePart && this.getInputRender('13395', 'LoosePartsType', undefined, 'list', this.props.loosePartType, ['Id', 'Name'])}
              {isLoosePart && this.getInputRender('286', 'ColorControlIncluded', undefined, 'checkbox')}

              {(hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && this.getInputRender('80', 'RekvNumber')}
              {(hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20)) && this.getInputRender('13386', 'LTW', undefined, 'checkbox')}
              {(hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20)) && this.state.order.LTW && this.getInputRender('13396', 'LTWIdCode')}

              {this.props.order.IsReferredIn && this.props.order.OrderConnection !== null && this.renderReferredIn()}
              {this.props.order.IsReferredOut && this.props.order.OrderConnection !== null && this.renderReferredOut()}

              <Divider noLine />

              {hasSubscriptionPermission(this.props.auth, 20) && $type !== 'data' && this.getInputRender('983', 'SuppressSMS', undefined, 'checkbox')}

              {(hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20)) && this.getInputRender('14764', 'HasPickupAltLocation', undefined, 'checkbox')}
              {(hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20)) && isPickup && renderList(translation('713'), '25', 'PickupAltLocationId')}
              {(hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20)) && isPickup && this.getInputRender('14769', 'PickupAltLocationComment')}

              {(hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20)) && this.getInputRender('14765', 'HasDeliveryAltLocation', undefined, 'checkbox')}
              {(hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20)) && isDelivery && renderList(translation('714'), '25', 'DeliveryAltLocationId')}
              {(hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20)) && isDelivery && this.getInputRender('14769', 'DeliveryAltLocationComment')}

            </div>
          )}
        </div>
      )
    }

    return this.props.auth.departmentType === 1 ? renderHeader(renderContent()) : renderPanel(renderContent())
  }

  renderTransportText () {
    let showTransport = this.state.order.CustomerShowTransport
    if (!showTransport) {
      return (
        <div className='pg-mb-2'>{translation('600')}</div>
      )
    }
  }

  renderReferredOut () {
    return (
      <div>
        <Text value={this.props.order.OrderConnection.TransportBefore} disabled labelText={translation('705')} />
        <Text value={this.props.order.OrderConnection.TransportAfter} disabled labelText={translation('707')} />
      </div>
    )
  }

  renderReferredIn () {
    return (
      <div>
        <Text value={this.props.order.OrderConnection.TransportBefore} disabled labelText={translation('705')} />
        <Text value={this.props.order.OrderConnection.TransportAfter} disabled labelText={translation('707')} />
      </div>
    )
  }

  renderVehicle (dimensions, $type = 'box', $screen = '') {
    if (dimensions !== null && !this.dimensionShow(dimensions)) return null
    let information = (
      <div className='information'>
        {this.getInputRender('78', 'RegNumber')}
        {this.getInputRender('145', 'BrandName', undefined, 'list', this.props.brands, ['Id', 'Name'], true)}
        {this.getInputRender('146', 'Model')}
        {this.getInputRender('147', 'Doors', undefined, 'list', this.props.doors, ['Id', 'Name'], false)}
        {this.getInputRender('347', 'RegistrationDate')}
        {this.getInputRender('81', 'ChassisNumber')}
        {this.props.auth.departmentType > 0 && this.getInputRender('16710', 'DistanceDriven')}
      </div>
    )

    return (
      <Panel title={translation('77')} dataCol='vehicle'>
        {information}
      </Panel>
    )
  }

  renderColor ($type = 'box', $limit) {
    if (this.props.auth.departmentType === 1 && !this.props.order.HasAvailablePaintPartner) return null
    let hasSubscriptionProLight = hasSubscriptionPermission(this.props.auth, 10, 0)
    // let extraClass = $type === 'data' ? 'clearBackground' : ''
    let hasLimit = $limit === '2cols'
    let inputRenderType = $type === 'data' ? 'inputicon' : 'input'
    let checkboxRenderType = $type === 'data' ? 'checkboxicon' : 'checkbox'

    const renderPanel = (content) => {
      return (
        <Panel title={translation('179')} dataCol='color'>
          {content}
        </Panel>
      )
    }

    const renderHeader = (content) => {
      return (
        <div data-col='color'>
          <PanelHeader text={translation('179')} />
          {content}
        </div>
      )
    }

    const renderContent = () => {
      return (
        <div className='information'>
          {this.getInputRender('179', 'Color', undefined, inputRenderType)}
          {this.getInputRender('79', 'ColorCode', undefined, inputRenderType)}
          {hasSubscriptionProLight && !hasLimit && this.getInputRender('13388', 'ColorVariant', undefined, inputRenderType)}
          {hasSubscriptionProLight && !hasLimit && this.getInputRender('13392', 'ColorAmount', undefined, inputRenderType)}
          {hasSubscriptionProLight && !hasLimit && this.getInputRender('13393', 'ColorIsReady', undefined, checkboxRenderType)}
        </div>
      )
    }

    return $type === 'data' ? renderHeader(renderContent()) : renderPanel(renderContent())
  }

  getContacts () {
    if (typeof this.state.order.CustomerId === 'undefined') return null
    this.props.getCustomer(this.state.order.CustomerId).then((res) => {
      let contacts = res.data.Contacts
      contacts = contacts.filter((contact) => {
        return (contact.Active) ? contact : false
      })
      this.setState({
        contacts: contacts
      })
    })
  }
  renderInsuranceDisplay () {
    if (!hasSubscriptionPermission(this.props.auth, 10)) return null
    if (this.state.InsuranceCompanies === undefined || this.state.order.OrderType !== OrderTypes.Insurance || this.state.order.InsuranceCompanyId == null) return null
    return (
      <div>
        <Text
          value={this.state.order.InsuranceCompanyName}
          disabled
          labelText={translation('418')}
        />
        <Text
          value={this.state.order.InsuranceAssessorName}
          disabled
          labelText={translation('14800')}
        />
      </div>
    )
  }
  renderCarOwnerPortal () {
    if (!this.props.auth.permissions.CarOwnerPortalEnabled) return null
    return (
      <CarOwnerPortalInviteStatus orderId={this.props.order.Id} />
    )
  }

  renderReferred () {
    if (this.props.auth.user.CustomerId !== '-1') return null
    if (this.props.order.OrderConnection === undefined || this.props.order.OrderConnection === null) return null

    return (
      <div>
        {this.props.order.IsReferredIn && this.props.order.OriginalShopName && (
          <Text
            value={this.props.order.OriginalShopName}
            disabled
            labelText={translation('17865')}
          />
        )}
        {this.props.order.IsReferredIn && (
          <Text
            value={(this.props.order.ShopNameReferredFrom) ? this.props.order.ShopNameReferredFrom : ''}
            disabled
            labelText={translation('719')}
          />
        )}
        {this.props.order.IsReferredOut && (
          <Text
            value={(this.props.order.ShopNameReferredTo) ? this.props.order.ShopNameReferredTo : ''}
            disabled
            labelText={translation('729')}
          />
        )}
      </div>
    )
  }

  renderCarOwnerPhoneList () {
    let carOwnerPhones = this.state.order.CarOwnerPhones

    if (carOwnerPhones.length === 0) {
      carOwnerPhones.push('')
    }

    const newNumber = (e) => {
      e.preventDefault()
      let carOwnerPhoneCount = this.state.carOwnerPhoneCount
      if (carOwnerPhoneCount < 4) {
        carOwnerPhoneCount++
        carOwnerPhones.push('')
        this.setState({
          carOwnerPhoneCount
        })
      }
    }

    const onChangePhone = (key, e) => {
      carOwnerPhones[key] = e.target.value
      this.setState({
        carOwnerPhones
      })
    }

    const onBlurPhone = (key, e) => {
      let data = this.state.order
      let carOwnerPhones = data.CarOwnerPhones
      carOwnerPhones[key] = e.target.value

      this.setState({
        data,
        carOwnerPhones
      }, () => {
        this.saveWorkcard(undefined, undefined, data).then(() => {
          EventEmitter.emit('UPDATE_CAROWNER')
          this.setState({
          }, () => {
          })
        })
      })
    }

    return (
      <div>
        {carOwnerPhones.map((val, key) => {
          if (val === null) { val = '' }
          return (
            <Text name='Text' value={val} key={'number_' + key} labelText={translation('14762')} onBlur={onBlurPhone.bind(this, key)} onChange={onChangePhone.bind(this, key)} />
          )
        })}
        <Button style='link' labelText={translation('17899')} disabled={carOwnerPhones.length === 4} onClick={newNumber} />
      </div>
    )
  }

  renderContact ($type = 'box') {
    const renderSelectList = () => {
      if (hasAccess([6], this.props.auth.user.UserType) || this.state.contacts.length === 0 || (!this.props.order.IsDraft && this.props.auth.user.CustomerId !== '-1')) return null
      const onChange = (e) => {
        this.state.contacts.map((contact) => {
          if (contact.UserId === parseInt(e.target.value)) {
            this.setState({
              order: {
                ...this.state.order,
                Contact: contact.Name,
                ContactPhone: contact.Phone || ''
              }
            }, this.saveWorkcard)
          }
        })
      }
      return (
        <DropDown value={0} onChange={onChange} labelText={translation('2242')}>
          <option value='0'>{translation('2242')}</option>
          {this.state.contacts.map((contact, k) => {
            return <option key={k} value={contact.UserId}>{contact.Name}</option>
          })}
        </DropDown>
      )
      // return (
      //   <div className='selectCustomer'>
      //     <label>{translation('2242')}</label>
      //     <select value={0} onChange={onChange} ref='contact__list'>
      //       <option value='0'>{translation('2242')}</option>
      //       {this.state.contacts.map((contact, k) => {
      //         return <option key={k} value={contact.UserId}>{contact.Name}</option>
      //       })}
      //     </select>
      //   </div>
      // )
    }
    const renderInsuranceDropdown = () => {
      let shownCustomer = this.state.order.CustomerName
      if (this.props.auth.allowNoCustomer && this.props.order.CustomerSelect === 1) {
        shownCustomer = translation('15330')
      }
      if (this.state.InsuranceCompanies === undefined) return null

      let noInsuranceId = this.state.order.InsuranceCompanyId === null
      let notInsurance = this.state.order.OrderType !== 1
      let lackingInsurance = notInsurance || noInsuranceId

      if (this.state.order.Report && !lackingInsurance) {
        return (
          <div>
            {this.renderInsuranceDisplay()}
            <Text
              value={shownCustomer}
              disabled
              labelText={translation('58')}
            />
          </div>
        )
      }
      if (!this.state.order.Report) {
        return (
          <div>
            {hasSubscriptionPermission(this.props.auth, 10) && (
              <DropDown name='InsuranceCompanyId' value={this.state.order.InsuranceCompanyId} onChange={this.onChange} labelText={translation('418')}>
                <option value='0'>{translation('418')}</option>
                {this.state.InsuranceCompanies.map((val, index) => {
                  if (val.Active) {
                    if (val.InsuranceCompanyId === this.state.order.InsuranceCompanyId) {
                      return (
                        <option value={val.InsuranceCompanyId} key={index} selected>{val.Company}</option>
                      )
                    } else {
                      return (
                        <option value={val.InsuranceCompanyId} key={index}>{val.Company}</option>
                      )
                    }
                  }
                })}
              </DropDown>
            )}
            {hasSubscriptionPermission(this.props.auth, 10) && !lackingInsurance && this.state.order.InsuranceAssessorName !== null && (
              <div>
                <Text
                  value={this.state.order.InsuranceAssessorName}
                  disabled
                  labelText={translation('14800')}
                />
              </div>
            )}
            <Text
              value={shownCustomer}
              disabled
              labelText={translation('58')}
            />
          </div>
        )
      }
    }

    let publishedBy = this.state.order.PublishedByUserInfo
    let publishedDate = 'PublishDate'
    let publishInfo = this.state.order.PublishedByShopName.length > 0 ? this.state.order.PublishedByShopName + '\n' : ''
    let isBooked = (!this.state.order.IsDraft && this.props.auth.user.DepartmentType !== 1) || (this.props.auth.user.DepartmentType === 1 && !this.state.order.BodyShopIsDraft)
    if (this.props.auth.user.DepartmentType === 1 && !this.state.order.BodyShopIsDraft) {
      publishedBy = this.state.order.BodyShopPublishedByUserInfo
      publishedDate = 'BodyShopPublishDate'
      if (this.state.order.BodyShopPublishedByShopName.length > 0) {
        publishInfo = this.state.order.BodyShopPublishedByShopName + '\n'
      }
    }
    if (this.state.order.PublishedByMail.length > 0 || this.state.order.PublishedByMobile.length > 0) {
      publishInfo += this.state.order.PublishedByMail + '\n' + this.state.order.PublishedByMobile
    }
    let createInfo = this.state.order.CreatedByShopName.length > 0 ? this.state.order.CreatedByShopName + '\n' : ''
    if (this.state.order.CreatedByMail.length > 0 || this.state.order.CreatedByMobile.length > 0) {
      createInfo += this.state.order.CreatedByMail + '\n' + this.state.order.CreatedByMobile
    }
    // console.log('[Workcard] auth', this.props.auth.user)

    // console.log('Workcard: this.props.auth', this.props.auth.permissions)

    return (
      <Panel title={translation('346')} dataCol='carownercustomer'>
        <div className='information'>
          {renderInsuranceDropdown()}
          {(hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && renderSelectList()}
          {(hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && this.getInputRender('346', 'Contact')}
          {(hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && this.getInputRender('345', 'ContactPhone')}
          {hasSubscriptionPermission(this.props.auth, 10) && this.getInputRender('16776', 'CarOwnerName')}
          {hasSubscriptionPermission(this.props.auth, 10) && this.getInputRender('16777', 'CarOwnerLastName')}
          {hasSubscriptionPermission(this.props.auth, 10) && this.getInputRender('18386', 'CarOwnerAddress')}
          {hasSubscriptionPermission(this.props.auth, 10) && this.getInputRender('18387', 'CarOwnerZipCode')}
          {hasSubscriptionPermission(this.props.auth, 10) && this.getInputRender('18388', 'CarOwnerCity')}
          {hasSubscriptionPermission(this.props.auth, 10) && this.renderCarOwnerPhoneList()}
          {hasSubscriptionPermission(this.props.auth, 10) && this.getInputRender('14763', 'CarOwnerMail')}
          {hasSubscriptionPermission(this.props.auth, 10) && this.getInputRender('16718', 'InsuranceDamageNr')}
          {this.renderCarOwnerPortal()}
          {this.renderReferred()}

          <LabelWrapper labelText={translation('263')} helpText={createInfo.length > 0 && createInfo}>
            <UserInfo user={this.state.order.CreatedByUserInfo} />
          </LabelWrapper>
          <LabelWrapper labelText={translation('13387')}>
            {renderFullDate(this.state.order.CreationDate)}
          </LabelWrapper>
          {isBooked && (
            <LabelWrapper labelText={translation('13011')} helpText={publishInfo.length > 0 && publishInfo}>
              <UserInfo user={publishedBy} />
            </LabelWrapper>
          )}
          {isBooked && (
            <LabelWrapper labelText={translation('13012')}>
              {renderFullDate(this.state.order[publishedDate])}
            </LabelWrapper>
          )}
        </div>
      </Panel>
    )
  }

  renderInvoice () {
    return (
      <Invoice invoiceOrder={this.state.order} updateOrder={this.props.onUpdateOrder} />
    )
  }

  renderForsiToken () {
    const { auth } = this.props
    const { order, InsuranceCompanies } = this.state
    let forsiEnable = auth.permissions.ChainAssessmentSystem === 1 // Forsi is available for the company

    // console.log("API", auth.permissions)
    if (!forsiEnable) return null
    if (!auth.permissions.UsesForsiTokenApi) return null
    if (order.OrderType !== OrderTypes.Insurance) return null

    const onSuccess = () => {
      let evaluationStopped = (!this.props.order.IsEvaluation || (this.props.order.IsEvaluation && !this.props.order.IsEvaluated)) && this.props.order.CustomerWPEvaluationRequired && this.props.order.IsAgreementOrder
      let evaluationRejected = this.props.order.IsEvaluation && !this.props.order.IsEvaluated && this.props.order.IsEvaluationRejected && this.props.order.CustomerWPEvaluationRequired && this.props.order.IsAgreementOrder

      if (evaluationStopped || evaluationRejected) {
        this.togglePopup('createEstimationPopup')
      }
    }

    return (
      <ForsiCreateReport order={order} forsi={InsuranceCompanies} onSuccess={onSuccess} />
    )
  }

  renderCustomer (dimensions, $type = 'box', $screen = '') {
    if (!this.dimensionShow(dimensions)) return null

    // Select list of customer contacts
    const renderSelectList = () => {
      if (hasAccess([6], this.props.auth.user.UserType) || this.state.contacts.length === 0 || (!this.props.order.IsDraft && this.props.auth.user.CustomerId !== '-1')) return null
      // const onChange = (e) => {
      //   e.preventDefault()
      //   console.log('ONCHAGNE', e.target.value, this.refs.contact__list.value)
      //   this.state.contacts.map((contact) => {
      //     if (contact.UserId === parseInt(this.refs.contact__list.value)) {
      //       this.setState({
      //         order: {
      //           ...this.state.order,
      //           Contact: contact.Name,
      //           ContactPhone: contact.Phone || ''
      //         }
      //       }, this.saveWorkcard)
      //     }
      //   })
      //   this.refs.contact__list.value = 0
      // }
      const onChange = (e) => {
        this.state.contacts.map((contact) => {
          if (contact.UserId === parseInt(e.target.value)) {
            this.setState({
              order: {
                ...this.state.order,
                Contact: contact.Name,
                ContactPhone: contact.Phone || ''
              }
            }, this.saveWorkcard)
          }
        })
      }
      return (
        <DropDown value={0} onChange={onChange}>
          <option value='0'>{translation('2242')}</option>
          {this.state.contacts.map((contact, k) => {
            return <option key={k} value={contact.UserId}>{contact.Name}</option>
          })}
        </DropDown>
      )
      // return (
      //   <div className='selectCustomer'>
      //     <label>{translation('2242')}</label>
      //     <select onChange={onChange} ref='contact__list'>
      //       <option value='0'>{translation('2242')}</option>
      //       {this.state.contacts.map((contact, k) => {
      //         return <option key={k} value={contact.UserId}>{contact.Name}</option>
      //       })}
      //     </select>
      //   </div>
      // )
    }
    let createInfo = this.state.order.CreatedByShopName.length > 0 ? this.state.order.CreatedByShopName + '\n' : ''
    if (this.state.order.CreatedByMail.length > 0 || this.state.order.CreatedByMobile.length > 0) {
      createInfo += this.state.order.CreatedByMail + '\n' + this.state.order.CreatedByMobile
    }
    let publishInfo = this.state.order.PublishedByShopName.length > 0 ? this.state.order.PublishedByShopName + '\n' : ''
    if (this.state.order.PublishedByMail.length > 0 || this.state.order.PublishedByMobile.length > 0) {
      publishInfo += this.state.order.PublishedByMail + '\n' + this.state.order.PublishedByMobile
    }
    // Render customer block
    if ($type === 'data') {
      return (
        <div className='white__box clearBackground' data-col='customer'>
          <div className='title'>
            <div className='icon titleIcon'>
              <img src='/images/svgs/workscreen/customer-contact-info.svg' alt={translation('179')} className='subtitleIMG' />
            </div>
            {translation('346')}
          </div>
          <div className='information'>
            {this.renderInsuranceDisplay()}
            {renderSelectList()}
            {this.getInputRender('363', 'CustomerName')}
            {(hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && this.getInputRender('346', 'Contact')}
            {(hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && this.getInputRender('345', 'ContactPhone')}
            {this.renderReferred()}
            <div>
              <label>{translation('263')}</label><UserInfo user={this.state.order.CreatedByUserInfo} />
              {(createInfo.length > 0) && <HelpText left className='helpText' text={createInfo} />}
            </div>
            {this.getInputRender('13387', 'CreationDate', renderFullDate)}
            {!this.state.order.IsDraft && (
              <div>
                <label>{translation('13011')}</label><UserInfo user={this.state.order.PublishedByUserInfo} />
                {(publishInfo.length > 0) && <HelpText left className='helpText' text={publishInfo} />}
              </div>
            )}
            {this.getInputRender('13012', 'PublishDate', renderFullDate)}
          </div>
        </div>
      )
    } else {
      return (
        <Panel title={translation('346')} dataCol='customer'>
          <div className='information'>
            {this.renderInsuranceDisplay()}
            {renderSelectList()}
            {this.getInputRender('363', 'CustomerName')}
            {(hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && this.getInputRender('346', 'Contact')}
            {(hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && this.getInputRender('345', 'ContactPhone')}
            {this.renderReferred()}

            <LabelWrapper labelText={translation('263')} helpText={(createInfo.length > 0) && createInfo}>
              <UserInfo user={this.state.order.CreatedByUserInfo} />
            </LabelWrapper>
            <LabelWrapper labelText={translation('13387')}>
              {renderFullDate(this.state.order.CreationDate)}
            </LabelWrapper>
            {!this.state.order.IsDraft && (
              <LabelWrapper labelText={translation('13011')} helpText={(publishInfo.length > 0) && publishInfo}>
                <UserInfo user={this.state.order.PublishedByUserInfo} />
              </LabelWrapper>
            )}
            <LabelWrapper labelText={translation('13012')}>
              {renderFullDate(this.state.order.PublishDate)}
            </LabelWrapper>
            {hasAccess([6], this.props.auth.user.UserType) && (
              <Text
                value={this.state.order.ShopName}
                disabled
                labelText={translation('14847')}
              />
            )}
          </div>
        </Panel>
      )
    }
  }

  renderFiles (dimensions, $type = 'box', $screen = '') {
    if (dimensions && !this.dimensionShow(dimensions)) return null
    return <Files type={$type} order={this.state.order} onUpdateOrder={this.props.onUpdateOrder} saveWorkcard={this.saveWorkcard} saveSingleValue={this.saveSingleValue} />
  }

  getPriceInformations () {
    if (!this.state.order || !this.state.order.BrandName) return null
    const { OrderType, BrandName, CustomerId } = this.state.order
    this.props.getPriceInformations(OrderType, BrandName.Name, CustomerId, null, false, false, this.state.order.Id)
      .then(({ data: { RefinishTypes, StartTimes, HourPrices, MaterialsShares } }) => {
        this.setState({
          priceInformation: {
            RefinishTypes,
            StartTimes,
            HourPrices,
            MaterialsShares
          }
        })
      })
  }

  onConfirmMissingBodywork () {
    this.onCloseConfirmMissingBodywork(true)
  }

  onCloseConfirmMissingBodywork (book) {
    this.setState({
      confirmMissingBodywork: {
        show: false
      }
    }, () => {
      this.props.triggerPopup(false) // modal-closed, backdrop-closed
      if (book === true) {
        setTimeout(() => {
          this.bookOrder(undefined, true) // backdrop-open
        }, 100)
      }
    })
  }

  renderConfirmMissingBodywork () {
    return (
      <Portal className='confirm_popup' onPortalClose={this.onCloseConfirmMissingBodywork.bind(this)}>
        <Confirm renderText={() => { return translation(16748) }} confirm={this.onConfirmMissingBodywork.bind(this)} notConfirm={this.onCloseConfirmMissingBodywork.bind(this)} />
      </Portal>
    )
  }

  renderConfirmPaintNotBooked () {
    const onClose = () => {
      this.setState({
        confirmPaintNotBooked: { open: false }
      })
    }
    return (
      <Portal className='confirm_popup' onPortalClose={onClose.bind(this)}>
        <ConfirmOk renderText={() => { return translation(15246) }} confirm={onClose.bind(this)} />
      </Portal>
    )
  }

  renderLoosepartPriceChangePopup () {
    const onClose = (isCancel) => {
      this.setState({
        loosepartChangeConfirmDialogOpen: false
      }, () => {
        if (isCancel) {
          postCancel()
        } else {
          this.props.onUpdateOrder()
        }
      })
    }

    const postCancel = () => {
      let postData = this.props.price
      postData.CancelEditing = true

      this.props.updatePrices(postData).then(res => {
        this.props.onUpdateOrder()
        if (typeof this.refs.price1 !== 'undefined') this.refs.price1.getWrappedInstance().getPrices()
        if (typeof this.refs.price2 !== 'undefined') this.refs.price2.getWrappedInstance().getPrices()
      })
    }
    // console.log('IN')
    if (this.props.price.RequireShopApproval) {
      // console.log('INRequire')
      const show = this.state.loosepartChangeConfirmDialogOpen && this.props.price.RequireShopApproval === true
      return (
        <PriceApprovalModal
          orderId={this.props.order.Id}
          show={show}
          closeModal={onClose}
          overflowHidden={false}
          priceInformation={this.state.priceInformation}
          showAE={this.state.order.showAE} />
      )
    }
  }

  dimensionShow (dimensions) {
    let show = false
    dimensions.map((val, key) => {
      if (!show) {
        let higherThan = val[0]
        let lessThan = val[1]
        let width = this.state.dimensions.width
        if (width > higherThan && width <= lessThan) show = true
      }
    })
    return show
  }

  togglePopup (prop, visible) {
    if (typeof visible !== 'boolean') {
      visible = !this.state[prop].show
    }
    if (!visible && prop === 'handleCarRentalPopup') {
      // After editing advanced car rentals in popup, reload order.
      this.props.onUpdateOrder()
    }
    this.setState({
      [prop]: {
        ...this.state[prop],
        show: visible
      }
    }, () => {
      // console.log('state.confirmMissingBodywork ', this.state.confirmMissingBodywork)
      this.props.triggerPopup(visible)
    })
  }

  renderSetCustomerPopup () {
    if (!this.state.showSetCustomerPopup.show) return null
    // console.log('[WorkCard] renderSetCustomerPopup')
    const updateOrder = (item) => {
      // console.log('[WorkCard] updateOrder trigger')
      this.props.onUpdateOrder()
    }
    return (
      <SetCustomer id={this.state.order.Id} item={this.state.order} close={this.togglePopup.bind(this, 'showSetCustomerPopup')} inModal updateOrder={updateOrder.bind(this)} />
    )
    // return (
    //   <Modal show onClose={this.togglePopup.bind(this, 'showSetCustomerPopup')} header={translation('2259')}>
    //     <SetCustomer id={this.state.order.Id} item={this.state.order} close={this.togglePopup.bind(this, 'showSetCustomerPopup')} inModal updateOrder={updateOrder.bind(this)} />
    //   </Modal>
    // )
  }

  renderCreateEstimationPopup () {
    if (!this.state.createEstimationPopup.show) return null
    let topMessage = [
      translation('13568')
    ]
    let returnOrder = true
    return (
      <CreateEstimationModal
        show={this.state.createEstimationPopup.show}
        topMessage={topMessage}
        id={this.state.order.Id}
        returnOrder={returnOrder}
        onClose={this.togglePopup.bind(this, 'createEstimationPopup', false)}
        onSave={this.onCreateEstimationSave}
      />
    )
  }

  renderHandleCarRentalPopup () {
    // console.log('this.state.handleCarRentalPopup ', this.state.handleCarRentalPopup)
    // console.log('this.state.order ', this.state.order)
    if (!this.state.handleCarRentalPopup.show) return null

    let { order } = this.state
    return (
      <HandleCarRentalModal
        show={this.state.handleCarRentalPopup.show}
        orderId={order.Id}
        customerId={order.CustomerId}
        pickup={order.BodyShopPickupTime}
        pickupTimes={order.BodyShopPickupTimes} // temporary prop ?
        delivery={order.BodyShopDeliveryTime}
        deliveryTimes={order.BodyShopDeliveryTimes} // temporary prop ?
        onClose={this.togglePopup.bind(this, 'handleCarRentalPopup', false)}
      />
    )
  }

  renderDracarInfoPopup () {
    if (!this.state.dracarVehicleCheck || !this.state.dracarInfoPopup.show) return null
    let text = []
    if (this.state.dracarVehicleCheck.foundVehicle) {
      if (this.state.dracarVehicleCheck.customers.length > 0) {
        text.push(translation('17846'))
        this.state.dracarVehicleCheck.customers.map((customer) => {
          text.push(
            <div>
              <span>{customer.Relationship}: </span>
              <span>{customer.FirstName}, {customer.LastName}</span>
            </div>
          )
        })
      } else {
        text.push(translation('17847'))
      }
    } else {
      text.push(translation('17848'))
    }
    return (
      <OkModal {...this.state.dracarInfoPopup} onClose={this.togglePopup.bind(this, 'dracarInfoPopup', false)}>
        {text}
      </OkModal>
    )
  }

  renderBodyShopStatus () {
    // Do not show body shop status for customer
    if (hasAccess([4], this.props.auth.user.UserType)) return null
    const renderList = (inputName, name, value) => {
      let data = [
        { BodyShopStatusId: 0, Name: translation('13054'), DisplayVal: translation('13054') },
        { BodyShopStatusId: 1, Name: translation('13053'), DisplayVal: translation('13053') }
      ]
      data.map((val, key) => { val.DisplayVal = val.Name })
      return this.getInputRender(inputName, value, undefined, 'list', data, ['BodyShopStatusId', 'DisplayVal'])
    }

    return [
      <div data-col='bodyshopstatus' key='0'>
        <form onSubmit={this.saveWorkcard} autoComplete='off'>
          {renderList('13052', '25', 'BodyShopSelectedStatus')}
        </form>
      </div>,
      <Divider key='1' />
    ]
  }

  renderPaintShopStatus () {
    if (hasAccess([4], this.props.auth.user.UserType)) return null
    return [
      <div data-col='paintshopstatus' key='0'>
        <form onSubmit={this.saveWorkcard} autoComplete='off'>
          <LabelWrapper labelText={translation('13052')}>
            {this.renderBookExternalLak()}
          </LabelWrapper>
        </form>
      </div>,
      <Divider key='1' />
    ]
  }

  render () {
    if (typeof this.props.order.Id === 'undefined' || typeof this.state.order === 'undefined') {
      const loadingSpinner = () => {
        return (
          <Panel>
            <div className='animated-background'>
              <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
              <span className='sr-only'>{translation('13382')}...</span>
            </div>
          </Panel>
        )
      }
      return (
        <div className='workcard__screen'>
          {this.props.disabled !== true && (
            <Header
              router={this.props.router}
              // title={title}
              showBack
              headerButtonsGoBack={this.props.renderButtonsGoBack}
              renderButtons={() => { return [<OrderBookingButton key={'booking'} order={this.props.order} togglePopup={this.togglePopup} bookOrder={this.bookOrder} regularBooking />] }}
              >
              {this.props.renderTabs()}
            </Header>
          )}
          <div className='row clearfix'>
            <Col>{loadingSpinner()}</Col>
            <Col>{loadingSpinner()}</Col>
            <div>
              <Col>
                {loadingSpinner()}
                {loadingSpinner()}
              </Col>
              <Col>
                {loadingSpinner()}
                {loadingSpinner()}
              </Col>
            </div>
          </div>
        </div>
      )
    }
    let disablePaintShopManuelPriceSetting = false
    // if (this.state.order.ForsiOrderExtent !== null) disablePaintShopManuelPriceSetting = true
    let {order} = this.state
    let hasForsiReport = order.Report !== null && order.Report.ReportType === 1
    if (hasForsiReport && order.Report.Paint) disablePaintShopManuelPriceSetting = true
    let disableMobileAccess = this.dimensionShow([Below650])

    const bodyshop = (isIntegration = false) => {
      // console.log('render bodyshop - isIntegration', isIntegration)
      let leftTitle = this.state.order.Id
      return (
        <Panel title={`${translation('788')} · ${leftTitle}`}>
          {!isIntegration && this.renderBodyShopStatus()}

          <div data-col='bodyshoptransport'>
            <form onSubmit={this.saveWorkcard} autoComplete='off'>
              {this.renderBodyShopTransport()}
            </form>
          </div>
          <Divider />
          <OrderExtent router={this.props.router} whitebox={false} type='' department='body' hideContent={false} onUpdateOrder={this.props.onUpdateOrder} />
        </Panel>
      )
    }
    const paint = (isIntegration = false) => {
      let isCustomer = this.props.auth.user.CustomerId !== '-1'
      return (
        <Panel title={translation('161')}>
          {!isCustomer && !isIntegration && this.props.order.HasAvailablePaintPartner && (
            this.renderPaintShopStatus()
          )}

          {!hasAccess([4], this.props.auth.user.UserType) && this.props.order.HasAvailablePaintPartner && [
            <div data-col='painttransport' key='0'>
              <form onSubmit={this.saveWorkcard} autoComplete='off'>
                {this.renderTransport('data')}
              </form>
            </div>,
            <Divider key='1' />
          ]}
          <form onSubmit={this.saveWorkcard} autoComplete='off'>
            {!isIntegration && this.renderColor('data', '2cols')}
            {isIntegration && this.renderColor('data')}
          </form>
          <Divider />
          <OrderExtent router={this.props.router} datacol='order' whitebox={false} type='data' department='' hideContent={false} editAllowed={disablePaintShopManuelPriceSetting} onUpdateOrder={this.props.onUpdateOrder} />
        </Panel>
      )
    }

    const col3 = (isCol) => {
      const renderContent = () => {
        return (
          <div>
            {this.dimensionShow([Between1055And1400]) && (
              <div className='section__status'>
                {this.renderInvoice()}
                {this.renderForsiToken()}
                {this.renderDracar()}
              </div>
            )}
            <SpareParts disableMobileAccess={disableMobileAccess} onUpdateOrder={this.props.onUpdateOrder} renderInput={this.getInputRender.bind(this)} order={this.state.order} saveWorkcard={this.saveWorkcard} saveSingleValue={this.saveSingleValue} />
            <form onSubmit={this.saveWorkcard} autoComplete='off'>
              {!isCol && this.renderVehicle([Below1055], 'box', 'plade/integration')}
            </form>
            {!isCol && this.dimensionShow([Below1055]) && this.renderNotes('box', 'plade')}
            {!isCol && this.renderFiles('', 'plade/integration')}
          </div>
        )
      }

      return isCol ? <Col>{renderContent()}</Col> : renderContent()
    }
    const col4 = (isCol) => {
      const renderContent = () => {
        return (
          <div>
            {this.dimensionShow([Above1400]) && (
              <div className='section__status'>
                {this.renderInvoice()}
                {this.renderForsiToken()}
                {this.renderDracar()}
              </div>
            )}
            {this.dimensionShow([Above1400]) && this.renderNotes('box', 'plade')}
            {this.renderFiles([Above1400], '', 'plade/integration')}
            {hasSubscriptionPermission(this.props.auth, 10) && (<form onSubmit={this.saveWorkcard} autoComplete='off'>
              {this.renderVehicle([Above1055, Below650], 'box', 'plade/integration')}
              {this.dimensionShow([Above1400, Below1055]) && this.renderContact()}
            </form>)}
          </div>
        )
      }

      return isCol ? <Col>{renderContent()}</Col> : renderContent()
    }
    // Free only column
    const col5 = (isCol) => {
      if (hasSubscriptionPermission(this.props.auth, 10)) return null

      const renderContent = () => {
        return (
          <div className={isCol ? 'col' : ''}>
            <form onSubmit={this.saveWorkcard} autoComplete='off'>
              {this.renderVehicle([Above1055, Below650], 'box', 'plade/integration')}
              {this.dimensionShow([Above1400, Below1055]) && this.renderContact()}
            </form>
          </div>
        )
      }

      return isCol ? <Col>{renderContent()}</Col> : renderContent()
    }

    let department = this.state.order.OrderDepartment
    let paintDepartment = department === 0
    let bodyDepartment = department === 1
    let combinedDepartment = department === 2
    let isMyPage = this.context.router.location.pathname.indexOf('mypage/orders/') > -1

    return (
      <div className='workcard__screen'>
        {!this.props.disabled && (
        <Header
          router={this.props.router}
          showBack
          headerButtonsGoBack={this.props.renderButtonsGoBack}
          renderButtons={() => { return [<OrderBookingButton key={'booking'} order={this.props.order} togglePopup={this.togglePopup} bookOrder={this.bookOrder} regularBooking />] }}
          >
          {this.props.renderTabs()}
        </Header>
        )}

        { /* <WorkCardHeader renderTitles={this.props.renderTitles} disabled={this.props.disabled} order={this.state.order} bookOrder={this.bookOrder} togglePopup={this.togglePopup}> */ }
        <div className='printTitle'>{this.props.common.pageTitle.title + '  (' + this.props.order.Id + ')'}</div>
        <fieldset disabled={this.props.disabled}>
          <div className='row clearfix'>

            {bodyDepartment && isMyPage && (
              <div className='col firstcol'>
                {this.dimensionShow([[0, 1055]]) && (
                  <div className='section__status'>
                    {this.renderInvoice()}
                    {this.renderForsiToken()}
                    {this.renderDracar()}
                  </div>
                )}
                {this.dimensionShow([[0, 10000]]) && bodyshop(combinedDepartment)}
                {this.dimensionShow([[0, 1055]]) && paint(combinedDepartment)}
                {this.dimensionShow([[0, 1300]]) && <SpareParts disableMobileAccess={false} onUpdateOrder={this.props.onUpdateOrder} renderInput={this.getInputRender.bind(this)} order={this.state.order} saveWorkcard={this.saveWorkcard} saveSingleValue={this.saveSingleValue} />}
                {this.dimensionShow([[0, 1055]]) && this.renderNotes()}
                {this.renderFiles([[0, 1055]], '', 'plade/integration')}
                <form onSubmit={this.saveWorkcard} autoComplete='off'>
                  {this.renderVehicle([[0, 1300]])}
                </form>
                <form onSubmit={this.saveWorkcard} autoComplete='off'>
                  {this.dimensionShow([[0, 1055]]) && this.renderContact()}
                </form>
                <form onSubmit={this.saveWorkcard} autoComplete='off'>
                  {this.dimensionShow([[1300, 10000]]) && this.renderContact()}
                </form>
              </div>
            )}
            {bodyDepartment && isMyPage && this.dimensionShow([[1055, 10000]]) && (
              <div className='col'>
                {this.dimensionShow([[1055, 1300]]) && (
                  <div className='section__status'>
                    {this.renderInvoice()}
                    {this.renderForsiToken()}
                    {this.renderDracar()}
                  </div>
                )}
                {this.dimensionShow([Above650]) && paint(combinedDepartment)}
                {this.renderNotes([[1055, 10000]])}
                {this.renderFiles([[1055, 10000]], '', 'plade/integration')}
                <form onSubmit={this.saveWorkcard} autoComplete='off'>
                  {this.dimensionShow([[1055, 1300]]) && this.renderContact()}
                </form>
              </div>
            )}
            {bodyDepartment && isMyPage && this.dimensionShow([[1300, 10000]]) && (
              <div className='col'>
                <div className='section__status'>
                  {this.renderInvoice()}
                  {this.renderForsiToken()}
                  {this.renderDracar()}
                </div>
                <SpareParts disableMobileAccess={false} onUpdateOrder={this.props.onUpdateOrder} renderInput={this.getInputRender.bind(this)} order={this.state.order} saveWorkcard={this.saveWorkcard} saveSingleValue={this.saveSingleValue} />

                <form onSubmit={this.saveWorkcard} autoComplete='off'>
                  {this.renderVehicle([[1300, 10000]])}
                </form>
              </div>
            )}

            {paintDepartment && isMyPage && (
              <div className='col firstcol'>
                {this.dimensionShow([[0, 1055]]) && (
                  <div className='section__status'>
                    {this.renderInvoice()}
                    {this.renderForsiToken()}
                    {this.renderDracar()}
                  </div>
                )}
                <WhiteBox titleId='paintTitle' titleIconAlt={translation('179')} titleText={translation('13360')}>
                  <OrderExtent router={this.props.router} datacol='order' whitebox={false} type='data' department='' hideContent={false} editAllowed={disablePaintShopManuelPriceSetting} onUpdateOrder={this.props.onUpdateOrder} />
                </WhiteBox>
                {this.dimensionShow([[0, 1055]]) && (<form onSubmit={this.saveWorkcard} autoComplete='off'>
                  {this.renderTransport()}
                </form>)}
                {this.dimensionShow([[0, 1055]]) && this.renderNotes()}
                {this.renderFiles([[0, 1055]], '', 'plade/integration')}
                {this.dimensionShow([[0, 1055]]) && this.renderColor()}
                <form onSubmit={this.saveWorkcard} autoComplete='off'>
                  {this.renderVehicle([[0, 10000]])}
                </form>
                <form onSubmit={this.saveWorkcard} autoComplete='off'>
                  {this.renderContact()}
                </form>
              </div>
            )}
            {paintDepartment && isMyPage && this.dimensionShow([[1055, 10000]]) && (
              <div className='col'>
                {this.dimensionShow([[1055, 1300]]) && (
                  <div className='section__status'>
                    {this.renderInvoice()}
                    {this.renderForsiToken()}
                    {this.renderDracar()}
                  </div>
                )}
                <form onSubmit={this.saveWorkcard} autoComplete='off'>
                  {this.renderTransport()}
                </form>
                {this.renderNotes()}
                {this.renderFiles([[1055, 10000]], '', 'plade/integration')}
                {this.dimensionShow([[1055, 1300]]) && this.renderColor()}
              </div>
            )}
            {paintDepartment && isMyPage && this.dimensionShow([[1300, 10000]]) && (
              <div className='col'>
                <div className='section__status'>
                  {this.renderInvoice()}
                  {this.renderForsiToken()}
                  {this.renderDracar()}
                </div>
                {this.renderColor()}
              </div>
            )}

            {paintDepartment && !isMyPage && (
              <Col>
                {this.dimensionShow([Below650]) && (
                  <div className='section__status'>
                    {this.renderInvoice()}
                    {this.renderForsiToken()}
                    {this.renderDracar()}
                  </div>
                )}
                <OrderExtent router={this.props.router} onUpdateOrder={this.props.onUpdateOrder} />
                <form onSubmit={this.saveWorkcard} autoComplete='off'>
                  {this.renderVehicle([Between650And1401])}
                  {this.renderCustomer([Between650And1401])}
                </form>
              </Col>
            )}

            {!paintDepartment && !isMyPage && this.dimensionShow([Below650]) && (
              <Col>
                <div className='section__status'>
                  {this.renderInvoice()}
                  {this.renderForsiToken()}
                  {this.renderDracar()}
                </div>
                {bodyshop(combinedDepartment)}
                {paint(combinedDepartment)}
                <SpareParts disableMobileAccess onUpdateOrder={this.props.onUpdateOrder} renderInput={this.getInputRender.bind(this)} order={this.state.order} saveWorkcard={this.saveWorkcard} saveSingleValue={this.saveSingleValue} />
                {this.renderNotes('box', 'plade')}
                {this.renderFiles([Below650], '', 'plade/integration')}
                <form onSubmit={this.saveWorkcard} autoComplete='off'>
                  {this.renderVehicle([Below650], 'box', 'plade/integration')}
                  {this.renderContact()}
                </form>
              </Col>
            )}
            {!paintDepartment && !isMyPage && this.dimensionShow([Above650]) && (
              <Col>
                {bodyshop(combinedDepartment)}
                <form onSubmit={this.saveWorkcard} autoComplete='off'>
                  {this.dimensionShow([Between1055And1400]) && this.renderContact()}
                </form>
                {this.dimensionShow([Below1055]) && col3(false)}
              </Col>
            )}

            {combinedDepartment && !isMyPage && this.dimensionShow([Above650]) && (
              <Col>
                {this.dimensionShow([[650, 1055]]) && (
                  <div className='section__status'>
                    {this.renderInvoice()}
                    {this.renderForsiToken()}
                    {this.renderDracar()}
                  </div>
                )}
                {paint(combinedDepartment)}
                {this.renderFiles([Between1055And1400], '', 'plade/integration')}
                {this.dimensionShow([Below1055]) && col4(false)}
              </Col>
            )}

            {paintDepartment && !isMyPage && (
              <Col>
                {this.dimensionShow([[650, 1055]]) && (
                  <div className='section__status'>
                    {this.renderInvoice()}
                    {this.renderForsiToken()}
                    {this.renderDracar()}
                  </div>
                )}
                <form onSubmit={this.saveWorkcard} autoComplete='off'>
                  {this.renderTransport()}
                </form>
                {this.renderNotes()}
                {this.renderFiles()}
              </Col>
            )}
            {paintDepartment && !isMyPage && (
              <div>
                <Col>
                  {this.dimensionShow([Between1055And1400]) && (
                    <div className='section__status'>
                      {this.renderInvoice()}
                      {this.renderForsiToken()}
                      {this.renderDracar()}
                    </div>
                  )}
                  <form onSubmit={this.saveWorkcard} autoComplete='off'>
                    {this.renderColor()}
                  </form>
                </Col>
                <Col>
                  {this.dimensionShow([Above1400]) && (
                    <div className='section__status'>
                      {this.renderInvoice()}
                      {this.renderForsiToken()}
                      {this.renderDracar()}
                    </div>
                  )}
                  <form onSubmit={this.saveWorkcard} autoComplete='off'>
                    {this.renderVehicle([Above1400, Below650])}
                    {this.renderCustomer([Above1400, Below650])}
                  </form>
                </Col>
              </div>
            )}

            {bodyDepartment && !isMyPage && this.dimensionShow([Above650]) && (
              <Col>
                {this.dimensionShow([[650, 1055]]) && (
                  <div className='section__status'>
                    {this.renderInvoice()}
                    {this.renderForsiToken()}
                    {this.renderDracar()}
                  </div>
                )}
                {paint(combinedDepartment)}
                {this.dimensionShow([Between1055And1400]) && this.renderNotes('box', 'plade')}
                {this.renderFiles([Between1055And1400], '', 'plade/integration')}
                {this.dimensionShow([Below1055]) && col4(false)}
              </Col>
            )}

            {!paintDepartment && !isMyPage && this.dimensionShow([Above1055]) && (
              <div>
                {col3(true)}
                {col4(true)}
                {col5(true)}
              </div>
            )}
          </div>
        </fieldset>
        <div className='row clearfix rowPrint' />
        {this.renderSetCustomerPopup()}
        {this.renderCreateEstimationPopup()}
        {this.renderHandleCarRentalPopup()}
        {this.renderDracarInfoPopup()}
        {this.state.loosepartChangeConfirmDialogOpen && this.renderLoosepartPriceChangePopup()}
        {this.state.confirmPaintNotBooked.open && this.renderConfirmPaintNotBooked()}
        {this.state.confirmMissingBodywork.show && this.renderConfirmMissingBodywork()}
        {this.state.confirmDelete.open && (
          <Portal className='confirm_popup' onPortalClose={this.onPortalClose.bind(this, 'confirmDelete')}>
            <Confirm confirm={this.onConfirm.bind(this)} notConfirm={this.onPortalClose.bind(this, 'confirmDelete')} />
          </Portal>
        )}
        {/* </WorkCardHeader> */}
      </div>
    )
  }

  onConfirm () {
    this.onPortalClose('confirmDelete')
    this.props.deleteNote(this.state.confirmDelete.NoteID).then((res) => {
      let newData = { ...this.state.order }
      newData.Notes = res.data.Notes
      this.props.onUpdateOrder(newData)
      // Toastr
      // window.toastr.success(translation('1895'), translation('13424'))
    }, () => {
      // Toastr
      window.toastr.error(translation('13441'), translation('216'))
    })
  }

  onPortalClose (type) {
    this.setState({
      [type]: {
        ...this.state[type],
        open: false,
        NoteID: 0
      }
    })
  }
}

WorkCard.propTypes = {
  triggerPopup: PropTypes.func.isRequired,
  deleteNote: PropTypes.func.isRequired
}
WorkCard.contextTypes = {
  // t: React.PropTypes.func.isRequired,
  // enum: React.PropTypes.func.isRequired,
  router: PropTypes.object
}
WorkCard.childContextTypes = {
  dimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  }),
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onUpdateOrder: PropTypes.func.isRequired,
  saveWorkcard: PropTypes.func.isRequired,
  disabledForWP: PropTypes.bool
}
function mapStateToProps (state) {
  return {
    auth: state.auth,
    price: state.price.price,
    order: state.orders.order,
    brands: state.common.brands,
    orderTypes: state.common.enums.orderTypes,
    transport: state.common.transport,
    doors: state.common.doors,
    loosePartType: state.common.loosePartType,
    common: state.common
  }
}

export default connect(mapStateToProps, {
  deleteNote,
  uploadFileToOrder,
  deleteFileFromOrder,
  saveOrder,
  setWorkcardOrder,
  bookOrder,
  isFileReady,
  getOrderVehicleData,
  getCustomer,
  getPrices,
  getOrderClean,
  triggerPopupActionBG,
  triggerPopup,
  GetSimpleCarRentals,
  GetAssignments,
  getInsuranceCompanies,
  updatePrices,
  getPriceInformations,
  setPageTitle,
  checkVehicleForCustomers,
  openOverlay
})(WorkCard)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/Order/NewWorkCard/index.js